/* NDT Shopify embed: horizon-about-gallery (source) */
(() => {
  const GLOBAL_KEY = "__ndtAboutGalleryRuntime";
  const MOBILE_MAX_WIDTH = 749;
  const MOBILE_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;
  const SECTION_CONTENT = '.section-content-wrapper[data-testid="section-content"]';
  const OFFER_SECTION_SELECTOR = "#shopify-section-template--16155450245253__section_pq7y7b";
  const OFFER_SUBTITLE_TEXT = "No Fluff! Just Exam Prep Tailored To Your Code Book";
  const OFFER_SUBTITLE_SELECTOR = ".text-block--AcTNOZ0VJS0FmZDNHY__text_wqXLHz";
  const OFFER_FIREWORKS_DELAY_MS = 3000;
  const OFFER_FIREWORKS_DURATION_MS = 3000;
  const FADE_VARIANTS = new Set(["v1", "v2"]);
  const DEFAULT_FADE_VARIANT = "v1";
  /* Technical rollout switch: set to "v2" to force the new fade globally. */
  const SCRIPT_FADE_VARIANT = "";
  const FADE_VARIANT_QUERY_PARAM = "ndtFade";
  const FADE_VARIANT_STORAGE_KEY = "ndtFadeVariant";
  const V1_CONTAINER_CLASSES = [
    "ndt-fadeinleft-ready",
    "ndt-fadeinleft-armed",
    "ndt-fadeinleft-started"
  ];
  const V1_ITEM_CLASSES = ["ndt-fadeinleft-item", "ndt-fadeinleft-visible"];
  const V2_CONTAINER_CLASSES = ["ndt-fadev2-ready", "ndt-fadev2-armed", "ndt-fadev2-started"];
  const V2_ITEM_CLASSES = ["ndt-fadev2-item", "ndt-fadev2-visible"];
  const V2_FALLBACK_CLASS = "ndt-fadev2-fallback";
  const V2_STYLE_KEYS = ["opacity", "transform", "transition", "transitionDelay", "willChange"];
  const V2_ANIMATION_EASING = "cubic-bezier(0, 0, 0.58, 1)";
  const BASE_GROUP_BLOCK_SELECTOR =
    ".group-block.group-block--height-fit.group-block--width-fill.border-style.spacing-style.size-style";
  const CARD_SELECTOR = [
    BASE_GROUP_BLOCK_SELECTOR,
    ".group-block",
    ".resource-card",
    ".collection-card",
    ".featured-blog-posts-card",
    ".product-grid__item",
    ".resource-list__item",
    ".article-card",
    ".blog-post-card"
  ].join(", ");

  const GALLERY_SECTIONS = [
    "#shopify-section-template--16158547247237__section_REaLYN",
    "#shopify-section-template--16158547247237__section_WgkL6w"
  ];

  const TARGET_SECTIONS = [
    "#shopify-section-template--16158547247237__section_pRBdn4",
    "#shopify-section-template--16158547247237__section_FtVPPm",
    "#shopify-section-template--16158547247237__section_REaLYN",
    "#shopify-section-template--16158547247237__section_WgkL6w",
    "#shopify-section-template--16158547247237__section_nPbTyE",
    "#shopify-section-template--16158547247237__section_UDFehE",
    "#shopify-section-template--16158547247237__section_U9Xab3",
    "#shopify-section-template--16158547247237__section_CcTdGp",
    "#shopify-section-template--16158547247237__section_99V4cY",
    "#shopify-section-template--16158713577605__product_list_fQaPt7",
    "#shopify-section-template--16155450245253__product_list_fa6P9H",
    "#shopify-section-template--16158713577605__section_QF4hWA",
    "#shopify-section-template--16158713577605__section_4ihGrT",
    "#shopify-section-template--16158713577605__section_DgpeCA",
    "#shopify-section-template--16158713577605__section_KQVDdT",
    "#shopify-section-template--16225002881157__section_DKwheR",
    "#shopify-section-sections--16155450671237__section_nN4MAy",
    "#shopify-section-sections--16155450671237__section_YDqGA7",
    "#shopify-section-sections--16155450671237__section_fCVnpT"
  ];
  const TARGET_SECTION_SELECTORS = Array.from(new Set(TARGET_SECTIONS));
  const TARGET_SECTION_IDS = new Set(TARGET_SECTION_SELECTORS.map((selector) => selector.slice(1)));
  const TARGET_SECTION_SUFFIXES = TARGET_SECTIONS.map((selector) => {
    const rawId = selector.startsWith("#") ? selector.slice(1) : selector;
    const markerIndex = rawId.indexOf("__");
    return markerIndex >= 0 ? rawId.slice(markerIndex) : "";
  }).filter(Boolean);
  const TARGET_SECTION_SUFFIX_SELECTORS = Array.from(
    new Set(
      TARGET_SECTION_SUFFIXES.map((idSuffix) => `[id^="shopify-section-"][id$="${idSuffix}"]`)
    )
  );
  const normalizeSectionId = (id) => {
    if (typeof id !== "string") {
      return "";
    }
    const value = id.trim().replace(/^#/, "");
    if (!value) {
      return "";
    }
    return value.startsWith("shopify-section-") ? value : `shopify-section-${value}`;
  };
  const isTargetSectionId = (id) => {
    if (typeof id !== "string" || !id.trim()) {
      return false;
    }
    const rawId = id.trim();
    const normalizedId = normalizeSectionId(rawId);
    if (TARGET_SECTION_IDS.has(rawId) || TARGET_SECTION_IDS.has(normalizedId)) {
      return true;
    }
    return TARGET_SECTION_SUFFIXES.some(
      (suffix) => rawId.endsWith(suffix) || normalizedId.endsWith(suffix)
    );
  };
  const getSectionFromEvent = (event) => {
    const eventTarget = event && event.target;
    if (eventTarget && typeof eventTarget.closest === "function") {
      const closestSection = eventTarget.closest('[id^="shopify-section-"]');
      if (closestSection && closestSection.id) {
        return closestSection;
      }
    }
    if (eventTarget && eventTarget.id && eventTarget.id.startsWith("shopify-section-")) {
      return eventTarget;
    }
    if (event && typeof event.composedPath === "function") {
      const path = event.composedPath();
      const sectionFromPath = path.find(
        (node) => node && node.id && typeof node.id === "string" && node.id.startsWith("shopify-section-")
      );
      if (sectionFromPath && sectionFromPath.id) {
        return sectionFromPath;
      }
    }
    return null;
  };
  const getSectionIdFromEventDetail = (event) => {
    if (!event || !event.detail) {
      return "";
    }
    if (typeof event.detail.sectionId === "string" && event.detail.sectionId.trim()) {
      return event.detail.sectionId.trim();
    }
    if (
      event.detail.section &&
      typeof event.detail.section.id === "string" &&
      event.detail.section.id.trim()
    ) {
      return event.detail.section.id.trim();
    }
    return "";
  };
  const normalizeFadeVariant = (value) => {
    if (typeof value !== "string") {
      return "";
    }
    const normalized = value.trim().toLowerCase();
    return FADE_VARIANTS.has(normalized) ? normalized : "";
  };

  const runtime = window[GLOBAL_KEY] || {
    galleryReady: false,
    scriptBound: false,
    fadeObservers: new Set(),
    fadeTimers: new Set(),
    fadeVariantOverride: "",
    lastFadeVariant: "",
    offerFireworksHandled: false,
    v2RevealRoots: new Map(),
    fadeAnimations: new Set(),
    v2StyleSnapshots: new WeakMap()
  };
  if (runtime.scriptBound) {
    return;
  }
  runtime.scriptBound = true;
  runtime.fadeObservers =
    runtime.fadeObservers instanceof Set ? runtime.fadeObservers : new Set();
  runtime.fadeTimers = runtime.fadeTimers instanceof Set ? runtime.fadeTimers : new Set();
  runtime.v2RevealRoots =
    runtime.v2RevealRoots instanceof Map ? runtime.v2RevealRoots : new Map();
  runtime.fadeAnimations =
    runtime.fadeAnimations instanceof Set ? runtime.fadeAnimations : new Set();
  runtime.v2StyleSnapshots =
    runtime.v2StyleSnapshots instanceof WeakMap ? runtime.v2StyleSnapshots : new WeakMap();
  runtime.fadeVariantOverride = normalizeFadeVariant(runtime.fadeVariantOverride);
  runtime.lastFadeVariant = normalizeFadeVariant(runtime.lastFadeVariant);
  window[GLOBAL_KEY] = runtime;

  const FALLBACK_CONTENT_SELECTORS = [
    '.resource-list[data-testid="resource-list-grid"]',
    ".resource-list",
    ".product-grid"
  ];

  const listChildren = (node) =>
    Array.from(node.children).filter(
      (child) =>
        child.nodeType === 1 &&
        !child.matches("script, style, link, template, noscript")
    );

  const getContainer = (section) => {
    if (!section) {
      return null;
    }

    const selectors = [SECTION_CONTENT].concat(FALLBACK_CONTENT_SELECTORS);
    for (const selector of selectors) {
      const container = section.querySelector(selector);
      if (container) {
        return container;
      }
    }

    return null;
  };

  const collectItems = (container) => {
    const direct = listChildren(container);
    if (direct.length < 1) {
      return [];
    }

    const directMatched = direct.filter((child) => child.matches(CARD_SELECTOR));
    if (directMatched.length > 0) {
      return directMatched;
    }

    if (direct.length > 1) {
      return direct;
    }

    const [single] = direct;
    const nested = [single].concat(
      Array.from(single.querySelectorAll(".resource-list, .resource-list--grid, .product-grid, ul, ol"))
    );
    const multi = nested.find((node) => listChildren(node).length > 1);
    if (multi) {
      const multiChildren = listChildren(multi);
      const nestedMatched = multiChildren.filter((child) => child.matches(CARD_SELECTOR));
      return nestedMatched.length > 0 ? nestedMatched : multiChildren;
    }

    const deepMatched = Array.from(single.querySelectorAll(CARD_SELECTOR));
    if (deepMatched.length > 1) {
      return deepMatched;
    }

    return direct;
  };
  const resolveV2RevealRoot = (container) => {
    if (!container) {
      return null;
    }
    const directChildren = listChildren(container);
    if (directChildren.length > 1) {
      return container;
    }
    const [single] = directChildren;
    if (!single) {
      return container;
    }
    const nestedCandidates = [single].concat(
      Array.from(
        single.querySelectorAll(
          '.resource-list[data-testid="resource-list-grid"], .resource-list, .product-grid'
        )
      )
    );
    const multiChildCandidate = nestedCandidates.find((node) => listChildren(node).length > 1);
    return multiChildCandidate || container;
  };
  const getManagedItems = (container) => {
    if (!container) {
      return [];
    }
    const collectedItems = collectItems(container);
    const fadedItems = Array.from(
      container.querySelectorAll(
        ".ndt-fadeinleft-item, .ndt-fadeinleft-visible, .ndt-fadev2-item, .ndt-fadev2-visible"
      )
    );
    return Array.from(new Set(collectedItems.concat(fadedItems))).filter(
      (item) => item && item.nodeType === 1
    );
  };
  const getManagedFadeContainers = (container) => {
    if (!container) {
      return [];
    }
    return [container].concat(
      Array.from(
        container.querySelectorAll(
          ".ndt-fadeinleft-ready, .ndt-fadeinleft-armed, .ndt-fadeinleft-started, .ndt-fadev2-ready, .ndt-fadev2-armed, .ndt-fadev2-started"
        )
      )
    );
  };
  const snapshotV2InlineStyles = (node) => {
    if (!node || runtime.v2StyleSnapshots.has(node)) {
      return;
    }
    runtime.v2StyleSnapshots.set(
      node,
      V2_STYLE_KEYS.reduce((snapshot, key) => {
        snapshot[key] = node.style[key];
        return snapshot;
      }, {})
    );
  };
  const restoreV2InlineStyles = (node) => {
    if (!node) {
      return;
    }
    const snapshot = runtime.v2StyleSnapshots.get(node);
    if (!snapshot) {
      return;
    }
    V2_STYLE_KEYS.forEach((key) => {
      node.style[key] = snapshot[key] || "";
    });
    runtime.v2StyleSnapshots.delete(node);
  };
  const bindAnimationLifecycle = (animation, handlers = {}) => {
    if (!animation) {
      return;
    }
    let settled = false;
    const run = (type) => {
      if (settled) {
        return;
      }
      settled = true;
      if (type === "finish" && typeof handlers.finish === "function") {
        handlers.finish();
      }
      if (type === "cancel" && typeof handlers.cancel === "function") {
        handlers.cancel();
      }
      if (typeof handlers.settle === "function") {
        handlers.settle(type);
      }
    };
    if (typeof animation.addEventListener === "function") {
      animation.addEventListener("finish", () => run("finish"), { once: true });
      animation.addEventListener("cancel", () => run("cancel"), { once: true });
      return;
    }
    if ("onfinish" in animation) {
      const previousOnFinish = animation.onfinish;
      animation.onfinish = (...args) => {
        if (typeof previousOnFinish === "function") {
          previousOnFinish.apply(animation, args);
        }
        run("finish");
      };
    }
    if ("oncancel" in animation) {
      const previousOnCancel = animation.oncancel;
      animation.oncancel = (...args) => {
        if (typeof previousOnCancel === "function") {
          previousOnCancel.apply(animation, args);
        }
        run("cancel");
      };
    }
    if (animation.finished && typeof animation.finished.then === "function") {
      animation.finished.then(
        () => run("finish"),
        () => run("cancel")
      );
    }
  };
  const registerFadeAnimation = (animation, target) => {
    if (!animation || !target) {
      return animation;
    }
    const record = { animation, target };
    runtime.fadeAnimations.add(record);
    bindAnimationLifecycle(animation, {
      settle: () => {
        runtime.fadeAnimations.delete(record);
      }
    });
    if (
      typeof animation.addEventListener !== "function" &&
      !("onfinish" in animation) &&
      !("oncancel" in animation) &&
      !(animation.finished && typeof animation.finished.then === "function")
    ) {
      runtime.fadeAnimations.delete(record);
    }
    return animation;
  };
  const cancelTrackedFadeAnimations = (container) => {
    runtime.fadeAnimations.forEach((record) => {
      const target = record && record.target;
      if (container && target && target !== container && !container.contains(target)) {
        return;
      }
      runtime.fadeAnimations.delete(record);
      if (record && record.animation && typeof record.animation.cancel === "function") {
        try {
          record.animation.cancel();
        } catch (error) {
          /* Ignore animation cancellation failures. */
        }
      }
    });
  };
  const resetFadeContainer = (container) => {
    if (!container) {
      return;
    }
    cancelTrackedFadeAnimations(container);
    getManagedFadeContainers(container).forEach((node) => {
      node.classList.remove(...V1_CONTAINER_CLASSES, ...V2_CONTAINER_CLASSES);
      node.classList.remove(V2_FALLBACK_CLASS);
      restoreV2InlineStyles(node);
    });
    getManagedItems(container).forEach((item) => {
      const hadV2Snapshot = runtime.v2StyleSnapshots.has(item);
      item.classList.remove(...V1_ITEM_CLASSES, ...V2_ITEM_CLASSES);
      restoreV2InlineStyles(item);
      if (!hadV2Snapshot) {
        item.style.transitionDelay = "";
      }
    });
  };
  const resetFadeSection = (section) => {
    const container = getContainer(section);
    if (!container) {
      return;
    }
    if (section && section.id) {
      runtime.v2RevealRoots.delete(section.id);
    }
    resetFadeContainer(container);
  };
  const registerFadeObserver = (observer) => {
    runtime.fadeObservers.add(observer);
    return observer;
  };
  const disconnectFadeObserver = (observer) => {
    if (!observer) {
      return;
    }
    runtime.fadeObservers.delete(observer);
    observer.disconnect();
  };
  const registerFadeTimer = (timerId) => {
    runtime.fadeTimers.add(timerId);
    return timerId;
  };
  const clearFadeTimer = (timerId) => {
    if (timerId == null) {
      return;
    }
    runtime.fadeTimers.delete(timerId);
    window.clearTimeout(timerId);
  };
  const resetTrackedFadeArtifacts = () => {
    runtime.fadeObservers.forEach((observer) => observer.disconnect());
    runtime.fadeObservers.clear();
    runtime.fadeTimers.forEach((timerId) => window.clearTimeout(timerId));
    runtime.fadeTimers.clear();
    cancelTrackedFadeAnimations();
  };
  const readFadeVariantFromQuery = () => {
    try {
      const params = new URL(window.location.href).searchParams;
      return normalizeFadeVariant(params.get(FADE_VARIANT_QUERY_PARAM));
    } catch (error) {
      return "";
    }
  };
  const readFadeVariantFromStorage = () => {
    try {
      return normalizeFadeVariant(window.localStorage.getItem(FADE_VARIANT_STORAGE_KEY));
    } catch (error) {
      return "";
    }
  };
  const writeFadeVariantToStorage = (variant) => {
    try {
      if (!variant) {
        window.localStorage.removeItem(FADE_VARIANT_STORAGE_KEY);
        return;
      }
      window.localStorage.setItem(FADE_VARIANT_STORAGE_KEY, variant);
    } catch (error) {
      /* Ignore storage access errors (private mode / blocked storage). */
    }
  };
  const resolveFadeVariant = () =>
    normalizeFadeVariant(runtime.fadeVariantOverride) ||
    normalizeFadeVariant(SCRIPT_FADE_VARIANT) ||
    readFadeVariantFromQuery() ||
    readFadeVariantFromStorage() ||
    DEFAULT_FADE_VARIANT;
  const getSectionStartDelay = (sectionId) =>
    sectionId === "shopify-section-template--16158713577605__section_QF4hWA"
      ? 0.18
      : sectionId === "shopify-section-template--16158713577605__section_4ihGrT"
        ? 0.05
        : sectionId === "shopify-section-template--16158713577605__section_KQVDdT"
          ? 0.05
          : 0;
  const getV1Stagger = (sectionId) =>
    sectionId === "shopify-section-template--16158713577605__section_4ihGrT" ||
    sectionId === "shopify-section-template--16158713577605__section_KQVDdT"
      ? 0.4
      : 0.16;

  const initFadeInLeftChain = (sectionRef, stagger = 0.16) => {
    const section =
      typeof sectionRef === "string" ? document.querySelector(sectionRef) : sectionRef;
    if (!section) {
      return;
    }

    const container = getContainer(section);
    if (!container) {
      return;
    }

    let items = collectItems(container);
    if (
      section.id === "shopify-section-template--16158713577605__section_4ihGrT" ||
      section.id === "shopify-section-template--16158713577605__section_DgpeCA" ||
      section.id === "shopify-section-template--16158713577605__section_KQVDdT"
    ) {
      const directPair = listChildren(container).filter((child) =>
        child.matches(".group-block, .image-block")
      );
      if (directPair.length >= 2) {
        items = directPair;
      }
    }
    if (items.length < 1) {
      return;
    }
    const liveItems = items.filter((item) => item.isConnected);
    if (liveItems.length < 1) {
      return;
    }

    const alreadyArmed =
      container.classList.contains("ndt-fadeinleft-ready") &&
      container.classList.contains("ndt-fadeinleft-armed") &&
      !container.classList.contains("ndt-fadeinleft-started");
    if (alreadyArmed) {
      const liveItemsArmed = liveItems.every((item) =>
        item.classList.contains("ndt-fadeinleft-item")
      );
      if (liveItemsArmed) {
        return;
      }
    }

    const alreadyStarted = container.classList.contains("ndt-fadeinleft-started");
    const liveItemsVisible = liveItems.every((item) =>
      item.classList.contains("ndt-fadeinleft-visible")
    );
    if (alreadyStarted && liveItemsVisible) {
      return;
    }

    const hasMatchMedia = typeof window.matchMedia === "function";
    const prefersReducedMotion =
      hasMatchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const isMobile = hasMatchMedia && window.matchMedia(MOBILE_QUERY).matches;

    container.classList.remove(...V1_CONTAINER_CLASSES);

    if (prefersReducedMotion) {
      liveItems.forEach((item) => {
        item.classList.remove(...V1_ITEM_CLASSES);
        item.style.transitionDelay = "";
      });
      return;
    }

    if (isMobile) {
      liveItems.forEach((item) => {
        item.classList.remove(...V1_ITEM_CLASSES);
        item.style.transitionDelay = "";
      });
      return;
    }

    const baseDelay = getSectionStartDelay(section.id);

    container.classList.add("ndt-fadeinleft-ready", "ndt-fadeinleft-armed");

    liveItems.forEach((item, index) => {
      item.classList.add("ndt-fadeinleft-item");
      item.style.transitionDelay = `${(baseDelay + index * stagger).toFixed(2)}s`;
    });

    let started = false;
    let revealedCount = 0;
    let observerStarted = false;
    let fallbackTimerId = null;

    const revealItem = (item) => {
      if (item.classList.contains("ndt-fadeinleft-visible")) {
        return;
      }
      item.classList.add("ndt-fadeinleft-visible");
      revealedCount += 1;
      if (revealedCount >= liveItems.length) {
        started = true;
        container.classList.add("ndt-fadeinleft-started");
        if (fallbackTimerId) {
          clearFadeTimer(fallbackTimerId);
          fallbackTimerId = null;
        }
      }
    };

    if (!("IntersectionObserver" in window)) {
      liveItems.forEach((item) => revealItem(item));
      return;
    }

    const observer = registerFadeObserver(
      new IntersectionObserver(
      (entries, obs) => {
        if (!section.isConnected || !container.isConnected) {
          disconnectFadeObserver(obs);
          return;
        }
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }
          observerStarted = true;
          revealItem(entry.target);
          obs.unobserve(entry.target);
          if (started) {
            disconnectFadeObserver(obs);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.01 }
      )
    );

    liveItems.forEach((item) => observer.observe(item));
    fallbackTimerId = registerFadeTimer(window.setTimeout(() => {
      if (!section.isConnected || !container.isConnected) {
        disconnectFadeObserver(observer);
        clearFadeTimer(fallbackTimerId);
        fallbackTimerId = null;
        return;
      }
      if (started) {
        clearFadeTimer(fallbackTimerId);
        fallbackTimerId = null;
        return;
      }
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      const rect = section.getBoundingClientRect();
      const sectionInViewport = rect.bottom > 0 && rect.top < viewportHeight;
      if (!observerStarted && !sectionInViewport) {
        clearFadeTimer(fallbackTimerId);
        fallbackTimerId = null;
        return;
      }
      /* If observer revealed only part of the set, force-complete to avoid hidden tail cards. */
      liveItems.forEach((item) => revealItem(item));
      disconnectFadeObserver(observer);
      clearFadeTimer(fallbackTimerId);
      fallbackTimerId = null;
    }, 1800));
  };
  const initFadeRevealV2 = (sectionRef, options = {}) => {
    const section =
      typeof sectionRef === "string" ? document.querySelector(sectionRef) : sectionRef;
    if (!section) {
      return;
    }

    const container = getContainer(section);
    if (!container) {
      return;
    }

    const revealRoot = resolveV2RevealRoot(container);
    if (!revealRoot) {
      return;
    }
    const previousRevealRoot = section.id ? runtime.v2RevealRoots.get(section.id) : null;
    if (previousRevealRoot && previousRevealRoot !== revealRoot) {
      resetFadeContainer(container);
    }
    const items = listChildren(revealRoot);
    if (items.length < 1) {
      return;
    }

    const liveItems = items.filter((item) => item.isConnected);
    if (liveItems.length < 1) {
      return;
    }

    const alreadyArmed =
      revealRoot.classList.contains("ndt-fadev2-ready") &&
      revealRoot.classList.contains("ndt-fadev2-armed") &&
      !revealRoot.classList.contains("ndt-fadev2-started");
    if (alreadyArmed) {
      const liveItemsArmed = liveItems.every((item) => item.classList.contains("ndt-fadev2-item"));
      if (liveItemsArmed) {
        if (section.id) {
          runtime.v2RevealRoots.set(section.id, revealRoot);
        }
        return;
      }
    }

    const alreadyStarted = revealRoot.classList.contains("ndt-fadev2-started");
    const liveItemsVisible = liveItems.every((item) =>
      item.classList.contains("ndt-fadev2-visible")
    );
    if (alreadyStarted && liveItemsVisible) {
      if (section.id) {
        runtime.v2RevealRoots.set(section.id, revealRoot);
      }
      return;
    }

    const hasMatchMedia = typeof window.matchMedia === "function";
    const prefersReducedMotion =
      hasMatchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const canAnimate =
      typeof Element !== "undefined" &&
      typeof Element.prototype.animate === "function" &&
      liveItems.every((item) => typeof item.animate === "function");

    revealRoot.classList.remove(...V2_CONTAINER_CLASSES);
    revealRoot.classList.remove(V2_FALLBACK_CLASS);
    liveItems.forEach((item) => {
      item.classList.remove(...V2_ITEM_CLASSES);
      restoreV2InlineStyles(item);
    });
    restoreV2InlineStyles(revealRoot);

    if (prefersReducedMotion) {
      if (section.id) {
        runtime.v2RevealRoots.set(section.id, revealRoot);
      }
      return;
    }

    const stagger = typeof options.stagger === "number" ? options.stagger : 0.25;
    const startDelay = typeof options.startDelay === "number" ? options.startDelay : 0;
    const threshold = typeof options.threshold === "number" ? options.threshold : 0.2;
    const duration = typeof options.duration === "number" ? options.duration : 1;
    const yOffset = typeof options.yOffset === "number" ? options.yOffset : 20;
    revealRoot.classList.add("ndt-fadev2-ready", "ndt-fadev2-armed");
    if (section.id) {
      runtime.v2RevealRoots.set(section.id, revealRoot);
    }
    if (canAnimate) {
      snapshotV2InlineStyles(revealRoot);
      revealRoot.style.opacity = "0";
      revealRoot.style.transition = "none";
      revealRoot.style.willChange = "opacity";
    } else {
      revealRoot.classList.add(V2_FALLBACK_CLASS);
    }
    liveItems.forEach((item, index) => {
      item.classList.add("ndt-fadev2-item");
      snapshotV2InlineStyles(item);
      if (canAnimate) {
        item.style.opacity = "0";
        item.style.transform = `translateY(${yOffset}px)`;
        item.style.transition = "none";
        item.style.transitionDelay = "";
        item.style.willChange = "opacity, transform";
        return;
      }
      item.style.transitionDelay = `${(startDelay + index * stagger).toFixed(2)}s`;
    });

    let started = false;
    let observerStarted = false;
    let fallbackTimerId = null;
    const startReveal = () => {
      if (started) {
        return;
      }
      started = true;
      revealRoot.classList.add("ndt-fadev2-started");
      liveItems.forEach((item) => item.classList.add("ndt-fadev2-visible"));
      if (canAnimate) {
        revealRoot.style.opacity = "1";
        revealRoot.style.willChange = "";
        liveItems.forEach((item, index) => {
          const animation = item.animate(
            [
              { opacity: 0, transform: `translateY(${yOffset}px)` },
              { opacity: 1, transform: "translateY(0)" }
            ],
            {
              duration: Math.round(duration * 1000),
              delay: Math.round((startDelay + index * stagger) * 1000),
              easing: V2_ANIMATION_EASING,
              fill: "both"
            }
          );
          registerFadeAnimation(animation, item);
          bindAnimationLifecycle(animation, {
            finish: () => {
              item.style.opacity = "1";
              item.style.transform = "translateY(0)";
              item.style.willChange = "";
            },
            cancel: () => {
              item.style.willChange = "";
            }
          });
        });
      }
      if (fallbackTimerId) {
        clearFadeTimer(fallbackTimerId);
        fallbackTimerId = null;
      }
    };

    if (!("IntersectionObserver" in window)) {
      startReveal();
      return;
    }

    const observer = registerFadeObserver(
      new IntersectionObserver(
        (entries, obs) => {
          if (!section.isConnected || !container.isConnected || !revealRoot.isConnected) {
            disconnectFadeObserver(obs);
            return;
          }
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }
            observerStarted = true;
            startReveal();
            disconnectFadeObserver(obs);
          });
        },
        { threshold }
      )
    );

    observer.observe(revealRoot);
    fallbackTimerId = registerFadeTimer(window.setTimeout(() => {
      if (!section.isConnected || !container.isConnected || !revealRoot.isConnected) {
        disconnectFadeObserver(observer);
        clearFadeTimer(fallbackTimerId);
        fallbackTimerId = null;
        return;
      }
      if (started) {
        clearFadeTimer(fallbackTimerId);
        fallbackTimerId = null;
        return;
      }
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      const rect = revealRoot.getBoundingClientRect();
      const revealRootInViewport = rect.bottom > 0 && rect.top < viewportHeight;
      if (!observerStarted && !revealRootInViewport) {
        clearFadeTimer(fallbackTimerId);
        fallbackTimerId = null;
        return;
      }
      startReveal();
      disconnectFadeObserver(observer);
      clearFadeTimer(fallbackTimerId);
      fallbackTimerId = null;
    }, 1800));
  };

  const getTargetSections = () => {
    const exactSections = TARGET_SECTION_SELECTORS.flatMap((selector) =>
      Array.from(document.querySelectorAll(selector))
    );
    const suffixSections = TARGET_SECTION_SUFFIX_SELECTORS.flatMap((selector) =>
      Array.from(document.querySelectorAll(selector))
    );
    if (exactSections.length < 1 && suffixSections.length < 1) {
      return [];
    }

    const explicitTargetSections = [];
    const explicitTargetIds = new Set();

    const addExplicitTarget = (section) => {
      if (!section || !section.id || explicitTargetIds.has(section.id)) {
        return;
      }
      explicitTargetIds.add(section.id);
      explicitTargetSections.push(section);
    };

    exactSections.forEach((section) => addExplicitTarget(section));
    suffixSections.forEach((section) => addExplicitTarget(section));
    return explicitTargetSections;
  };
  const runFade = () => {
    const explicitTargetSections = getTargetSections();
    if (explicitTargetSections.length < 1) {
      return;
    }

    const activeVariant = resolveFadeVariant();
    if (runtime.lastFadeVariant && runtime.lastFadeVariant !== activeVariant) {
      resetTrackedFadeArtifacts();
      explicitTargetSections.forEach((section) => resetFadeSection(section));
    }
    runtime.lastFadeVariant = activeVariant;

    explicitTargetSections.forEach((section) => {
      if (activeVariant === "v2") {
        initFadeRevealV2(section, {
          stagger: 0.25,
          threshold: 0.2
        });
        return;
      }
      initFadeInLeftChain(section, getV1Stagger(section.id));
    });
  };

  const initGallery = () => {
    const groups = GALLERY_SECTIONS.map((selector) => {
      const section = document.querySelector(selector);
      if (!section) {
        return null;
      }
      const images = Array.from(section.querySelectorAll(".image-block__image"));
      if (images.length < 1) {
        return null;
      }
      return { images };
    }).filter(Boolean);

    if (groups.length < 1) {
      return;
    }

    let modal = document.querySelector(".ndt-about-gallery");
    if (!modal) {
      modal = document.createElement("div");
      modal.className = "ndt-about-gallery";
      modal.setAttribute("aria-hidden", "true");
      modal.innerHTML =
        '<button class="ndt-about-gallery__close" type="button" aria-label="Close gallery">&times;</button>' +
        '<button class="ndt-about-gallery__btn ndt-about-gallery__btn--prev" type="button" aria-label="Previous image">&lsaquo;</button>' +
        '<img class="ndt-about-gallery__image" alt="">' +
        '<button class="ndt-about-gallery__btn ndt-about-gallery__btn--next" type="button" aria-label="Next image">&rsaquo;</button>' +
        '<div class="ndt-about-gallery__counter"></div>';
      document.body.appendChild(modal);
    }

    const modalImage = modal.querySelector(".ndt-about-gallery__image");
    const modalCounter = modal.querySelector(".ndt-about-gallery__counter");
    const closeButton = modal.querySelector(".ndt-about-gallery__close");
    const prevButton = modal.querySelector(".ndt-about-gallery__btn--prev");
    const nextButton = modal.querySelector(".ndt-about-gallery__btn--next");

    let activeImages = groups[0].images;
    let activeIndex = 0;
    let touchStartX = 0;

    const render = () => {
      const current = activeImages[activeIndex];
      modalImage.src = current.currentSrc || current.src || "";
      modalImage.alt = current.alt || "";
      modalCounter.textContent = `${activeIndex + 1} / ${activeImages.length}`;
    };

    const open = (images, index) => {
      activeImages = images;
      activeIndex = (index + activeImages.length) % activeImages.length;
      render();
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    };

    const close = () => {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    };

    const next = () => {
      activeIndex = (activeIndex + 1) % activeImages.length;
      render();
    };

    const prev = () => {
      activeIndex = (activeIndex - 1 + activeImages.length) % activeImages.length;
      render();
    };

    groups.forEach(({ images }) => {
      images.forEach((image, index) => {
        if (image.dataset.ndtGalleryBound === "1") {
          return;
        }
        image.dataset.ndtGalleryBound = "1";
        image.style.cursor = "zoom-in";
        image.setAttribute("tabindex", "0");
        image.setAttribute("role", "button");
        image.setAttribute("aria-label", "Open image gallery");
        image.addEventListener("click", () => open(images, index));
        image.addEventListener("keydown", (event) => {
          if (event.key !== "Enter" && event.key !== " ") {
            return;
          }
          event.preventDefault();
          open(images, index);
        });
      });
    });

    if (runtime.galleryReady) {
      return;
    }

    runtime.galleryReady = true;
    closeButton.addEventListener("click", close);
    nextButton.addEventListener("click", next);
    prevButton.addEventListener("click", prev);

    modal.addEventListener("click", (event) => {
      if (event.target === modal) {
        close();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (!modal.classList.contains("is-open")) {
        return;
      }
      if (event.key === "Escape") {
        close();
      }
      if (event.key === "ArrowRight") {
        next();
      }
      if (event.key === "ArrowLeft") {
        prev();
      }
    });

    modal.addEventListener(
      "touchstart",
      (event) => {
        touchStartX = event.changedTouches[0].screenX;
      },
      { passive: true }
    );

    modal.addEventListener(
      "touchend",
      (event) => {
        const delta = event.changedTouches[0].screenX - touchStartX;
        if (Math.abs(delta) < 40) {
          return;
        }
        if (delta < 0) {
          next();
        } else {
          prev();
        }
      },
      { passive: true }
    );
  };

  const normalizeOfferText = (value) =>
    typeof value === "string" ? value.replace(/\s+/g, " ").trim() : "";

  const getOfferReplacementTarget = (node, section) => {
    if (!node || !section || node === section) {
      return null;
    }
    const wrapper = node.closest("rte-formatter, .text-block");
    return wrapper && section.contains(wrapper) ? wrapper : node;
  };

  const findOfferSubtitle = (section) => {
    if (!section) {
      return null;
    }
    const candidates = Array.from(
      section.querySelectorAll("rte-formatter, .text-block, h1, h2, h3, h4, p, span")
    );
    const exactMatch = candidates.find(
      (candidate) => normalizeOfferText(candidate.textContent) === OFFER_SUBTITLE_TEXT
    );
    if (exactMatch) {
      return getOfferReplacementTarget(exactMatch, section);
    }
    const fallback = section.querySelector(OFFER_SUBTITLE_SELECTOR);
    return fallback ? getOfferReplacementTarget(fallback, section) : null;
  };

  const buildOfferBlock = () => {
    const block = document.createElement("div");
    block.className = "ndt-limited-offer";
    block.innerHTML =
      '<div class="ndt-limited-offer__label">Level 1 courses</div>' +
      '<div class="ndt-limited-offer__price">' +
      '<span class="ndt-limited-offer__current">$260</span>' +
      '<s class="ndt-limited-offer__compare">$420</s>' +
      '<span class="ndt-limited-offer__discount">(-38%)</span>' +
      '</div>' +
      '<div class="ndt-limited-offer__note">VT Level 1: $140 (was $230)</div>';
    return block;
  };

  const initOfferFireworks = () => {
    if (runtime.offerFireworksHandled) {
      return;
    }
    runtime.offerFireworksHandled = true;
    const motionQuery = typeof window.matchMedia === "function"
      ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
    if (!motionQuery || motionQuery.matches || document.visibilityState !== "visible") {
      return;
    }

    let startTimer = null;
    let endTimer = null;
    let overlay = null;
    let frameId = null;
    const stop = () => {
      window.clearTimeout(startTimer);
      window.clearTimeout(endTimer);
      window.cancelAnimationFrame(frameId);
      frameId = null;
      if (overlay) {
        overlay.remove();
        overlay = null;
      }
      window.removeEventListener("pagehide", stop);
      document.removeEventListener("visibilitychange", onVisibilityChange);
      if (typeof motionQuery.removeEventListener === "function") {
        motionQuery.removeEventListener("change", onMotionChange);
      } else if (typeof motionQuery.removeListener === "function") {
        motionQuery.removeListener(onMotionChange);
      }
    };
    const onVisibilityChange = () => {
      if (document.visibilityState !== "visible") {
        stop();
      }
    };
    const onMotionChange = () => {
      if (motionQuery.matches) {
        stop();
      }
    };
    const start = () => {
      startTimer = null;
      try {
        const price = document.querySelector(`${OFFER_SECTION_SELECTOR} .ndt-limited-offer__price`);
        if (!price || !price.getClientRects().length || motionQuery.matches || document.visibilityState !== "visible") {
          stop();
          return;
        }
        overlay = document.createElement("span");
        overlay.className = "ndt-offer-fireworks";
        overlay.setAttribute("aria-hidden", "true");
        const canvas = document.createElement("canvas");
        canvas.className = "ndt-offer-fireworks__canvas";
        overlay.appendChild(canvas);
        price.appendChild(overlay);
        const context = canvas.getContext("2d");
        if (!context) {
          window.console.error("[ndt-offer-fireworks] stage=canvas code=CONTEXT_UNAVAILABLE");
          stop();
          return;
        }
        const box = overlay.getBoundingClientRect();
        const width = Math.min(640, Math.max(1, box.width));
        const height = Math.min(256, Math.max(1, box.height));
        const ratio = Math.min(2, Math.max(1, window.devicePixelRatio || 1));
        canvas.width = Math.ceil(width * ratio);
        canvas.height = Math.ceil(height * ratio);
        context.setTransform(ratio, 0, 0, ratio, 0, 0);
        context.lineCap = "round";
        context.lineJoin = "round";
        const colors = ["#ffdc58", "#ff73bc", "#61e8ff", "#b29bff", "#ffffff", "#74f2bf"];
        // Cache the soft, white-hot cores once; no per-frame blur or gradients.
        const glows = colors.map(color => {
          const sprite = document.createElement("canvas");
          sprite.width = sprite.height = 32;
          const brush = sprite.getContext("2d");
          if (!brush) throw new Error("Glow context unavailable");
          const glow = brush.createRadialGradient(16, 16, 0, 16, 16, 16);
          glow.addColorStop(0, "#ffffff");
          glow.addColorStop(0.12, "#ffffff");
          glow.addColorStop(0.28, color);
          glow.addColorStop(0.55, `${color}70`);
          glow.addColorStop(1, `${color}00`);
          brush.fillStyle = glow;
          brush.fillRect(0, 0, 32, 32);
          return sprite;
        });
        let seed = 19;
        const random = () => {
          seed = (seed * 1664525 + 1013904223) >>> 0;
          return seed / 4294967296;
        };
        const particles = [];
        const bursts = [
          { x: 0.29, y: 0.43, delay: 0, count: 80, speed: 1, life: 2300, palette: [0, 4, 2, 5] },
          { x: 0.71, y: 0.4, delay: 380, count: 80, speed: 1, life: 2400, palette: [1, 3, 4, 0] },
          { x: 0.5, y: 0.25, delay: 760, count: 48, speed: 0.6, life: 2240, palette: [0, 4, 2, 3] }
        ];
        for (const burst of bursts) {
          for (let index = 0; index < burst.count; index += 1) {
            const angle = (index / burst.count) * Math.PI * 2 + (random() - 0.5) * 0.1;
            const speed = (60 + random() * 95) * burst.speed * Math.min(1, width / 340);
            particles.push({
              x: width * burst.x, y: height * burst.y,
              vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed * 0.78 - 12,
              drag: 1.35 + random() * 0.35, gravity: 24,
              delay: burst.delay, life: burst.life,
              color: burst.palette[index % burst.palette.length],
              size: 4.5 + random() * 2, phase: random() * Math.PI * 2,
              head: {}, middle: {}, tail: {}, glitter: false
            });
          }
        }
        for (let index = 0; index < 24; index += 1) {
          const delay = 400 + random() * 700;
          particles.push({
            x: width * (0.18 + random() * 0.64), y: height * 0.42,
            vx: (random() - 0.5) * 70, vy: -35 - random() * 35,
            drag: 1.1, gravity: 32, delay, life: OFFER_FIREWORKS_DURATION_MS - delay,
            color: index % colors.length, size: 5, phase: random() * Math.PI * 2,
            head: {}, tail: {}, glitter: true
          });
        }
        const position = (particle, age, target) => {
          const travel = (1 - Math.exp(-particle.drag * age)) / particle.drag;
          target.x = particle.x + particle.vx * travel;
          target.y = particle.y + particle.vy * travel + particle.gravity * age * age / 2;
        };
        const startedAt = window.performance.now();
        let lastDraw = startedAt - 16;
        const draw = now => {
          frameId = null;
          if (!overlay) return;
          const elapsed = now - startedAt;
          if (elapsed >= OFFER_FIREWORKS_DURATION_MS) {
            stop();
            return;
          }
          try {
            if (now - lastDraw >= 16) {
              lastDraw = now;
              context.clearRect(0, 0, width, height);
              context.globalCompositeOperation = "lighter";
              const finish = Math.min(1, (OFFER_FIREWORKS_DURATION_MS - elapsed) / 250);
              for (const particle of particles) {
                const ageMs = elapsed - particle.delay;
                if (ageMs <= 0 || ageMs >= particle.life) continue;
                const age = ageMs / 1000;
                const progress = ageMs / particle.life;
                const alpha = Math.min(1, ageMs / 70) * Math.pow(1 - progress, 0.7) * finish;
                position(particle, age, particle.head);
                if (!particle.glitter) {
                  position(particle, Math.max(0, age - 0.3), particle.tail);
                  position(particle, Math.max(0, age - 0.1), particle.middle);
                  context.globalAlpha = alpha * 0.24;
                  context.strokeStyle = colors[particle.color];
                  context.lineWidth = 0.4;
                  context.beginPath();
                  context.moveTo(particle.tail.x, particle.tail.y);
                  context.lineTo(particle.head.x, particle.head.y);
                  context.stroke();
                  context.globalAlpha = alpha * 0.65;
                  context.lineWidth = 0.8;
                  context.beginPath();
                  context.moveTo(particle.middle.x, particle.middle.y);
                  context.lineTo(particle.head.x, particle.head.y);
                  context.stroke();
                } else {
                  context.globalAlpha = alpha * 0.8;
                  context.fillStyle = colors[particle.color];
                  context.save();
                  context.translate(particle.head.x, particle.head.y);
                  context.rotate(age * 2 + particle.phase);
                  context.fillRect(-0.8, -1.4, 1.6, 2.8);
                  context.restore();
                }
                context.globalAlpha = alpha * (0.8 + 0.2 * Math.sin(age * 9 + particle.phase));
                context.drawImage(glows[particle.color], particle.head.x - particle.size / 2,
                  particle.head.y - particle.size / 2, particle.size, particle.size);
              }
            }
            frameId = window.requestAnimationFrame(draw);
          } catch (error) {
            window.console.error("[ndt-offer-fireworks] stage=frame code=DRAW_FAILED");
            stop();
          }
        };
        canvas.addEventListener("contextlost", () => {
          window.console.error("[ndt-offer-fireworks] stage=canvas code=CONTEXT_LOST");
          stop();
        }, { once: true });
        endTimer = window.setTimeout(stop, OFFER_FIREWORKS_DURATION_MS);
        draw(startedAt);
      } catch (error) {
        window.console.error("[ndt-offer-fireworks] stage=render code=DECORATION_FAILED");
        stop();
      }
    };
    window.addEventListener("pagehide", stop, { once: true });
    document.addEventListener("visibilitychange", onVisibilityChange);
    if (typeof motionQuery.addEventListener === "function") {
      motionQuery.addEventListener("change", onMotionChange);
    } else if (typeof motionQuery.addListener === "function") {
      motionQuery.addListener(onMotionChange);
    }
    // initLimitedOffer has the price ready; slow images must not postpone it.
    startTimer = window.setTimeout(start, OFFER_FIREWORKS_DELAY_MS);
  };

  const initLimitedOffer = () => {
    const section = document.querySelector(OFFER_SECTION_SELECTOR);
    if (!section) {
      return;
    }

    let block = section.querySelector(".ndt-limited-offer");
    if (!block) {
      const subtitle = findOfferSubtitle(section);
      if (!subtitle) {
        return;
      }
      block = buildOfferBlock();
      subtitle.replaceWith(block);
    }

    initOfferFireworks();
  };

  const boot = () => {
    try {
      initLimitedOffer();
    } catch (error) {
      if (window.console && typeof window.console.error === "function") {
        window.console.error("[ndt-fade] boot initLimitedOffer failed", error);
      }
    }
    try {
      runFade();
    } catch (error) {
      if (window.console && typeof window.console.error === "function") {
        window.console.error("[ndt-fade] boot runFade failed", error);
      }
    }
    try {
      initGallery();
    } catch (error) {
      if (window.console && typeof window.console.error === "function") {
        window.console.error("[ndt-fade] boot initGallery failed", error);
      }
    }
  };

  let refreshRafId = null;
  const runSafely = (fn, label) => {
    try {
      fn();
    } catch (error) {
      if (window.console && typeof window.console.error === "function") {
        window.console.error(`[ndt-fade] ${label} failed`, error);
      }
    }
  };
  const scheduleRefresh = () => {
    if (refreshRafId) {
      return;
    }
    const flush = () => {
      refreshRafId = null;
      runSafely(initLimitedOffer, "initLimitedOffer");
      runSafely(runFade, "runFade");
      runSafely(initGallery, "initGallery");
    };
    if (typeof window.requestAnimationFrame === "function") {
      refreshRafId = window.requestAnimationFrame(flush);
      return;
    }
    refreshRafId = window.setTimeout(flush, 16);
  };
  const resetAllTargetFadeState = () => {
    resetTrackedFadeArtifacts();
    getTargetSections().forEach((section) => resetFadeSection(section));
    runtime.lastFadeVariant = "";
  };
  const setFadeVariant = (variant, options = {}) => {
    const nextVariant = normalizeFadeVariant(variant);
    if (!nextVariant) {
      return false;
    }
    runtime.fadeVariantOverride = nextVariant;
    if (options.persist !== false) {
      writeFadeVariantToStorage(nextVariant);
    }
    resetAllTargetFadeState();
    scheduleRefresh();
    return true;
  };
  const clearFadeVariantOverride = (options = {}) => {
    runtime.fadeVariantOverride = "";
    if (options.persist !== false) {
      writeFadeVariantToStorage("");
    }
    resetAllTargetFadeState();
    scheduleRefresh();
  };
  window.__ndtFade = {
    clearVariantOverride: clearFadeVariantOverride,
    getVariant: resolveFadeVariant,
    refresh: () => {
      resetAllTargetFadeState();
      scheduleRefresh();
    },
    setVariant: (variant) => setFadeVariant(variant)
  };

  const bindViewportBreakpointRefresh = () => {
    if (typeof window.matchMedia !== "function") {
      return;
    }
    const mobileQuery = window.matchMedia(MOBILE_QUERY);
    let lastIsMobile = mobileQuery.matches;
    const onChange = (event) => {
      const nextIsMobile =
        event && typeof event.matches === "boolean" ? event.matches : mobileQuery.matches;
      if (nextIsMobile === lastIsMobile) {
        return;
      }
      lastIsMobile = nextIsMobile;
      scheduleRefresh();
    };
    if (typeof mobileQuery.addEventListener === "function") {
      mobileQuery.addEventListener("change", onChange);
      return;
    }
    if (typeof mobileQuery.addListener === "function") {
      mobileQuery.addListener(onChange);
    }
  };
  const bindResizeBreakpointRefresh = () => {
    let lastIsMobile = window.innerWidth <= MOBILE_MAX_WIDTH;
    window.addEventListener("resize", () => {
      const nextIsMobile = window.innerWidth <= MOBILE_MAX_WIDTH;
      if (nextIsMobile === lastIsMobile) {
        return;
      }
      lastIsMobile = nextIsMobile;
      scheduleRefresh();
    });
  };

  const shouldRefreshForSectionEvent = (event) => {
    const detailSectionId = getSectionIdFromEventDetail(event);
    if (detailSectionId) {
      return isTargetSectionId(detailSectionId);
    }

    const section = getSectionFromEvent(event);
    if (!section || !section.id) {
      return true;
    }
    return isTargetSectionId(section.id);
  };
  const cleanupFadeStateForEvent = (event) => {
    const detailSectionId = normalizeSectionId(getSectionIdFromEventDetail(event));
    if (detailSectionId && isTargetSectionId(detailSectionId)) {
      runtime.v2RevealRoots.delete(detailSectionId);
    }
    const section = getSectionFromEvent(event);
    if (section && section.id && isTargetSectionId(section.id)) {
      resetFadeSection(section);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener(
    "load",
    () => {
      /* One late pass for sections rendered after DOM ready; started sections are guarded. */
      scheduleRefresh();
    },
    { once: true }
  );

  window.addEventListener("pageshow", () => {
    scheduleRefresh();
  });
  window.addEventListener("orientationchange", () => {
    scheduleRefresh();
  });
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState !== "visible") {
      return;
    }
    scheduleRefresh();
  });
  bindViewportBreakpointRefresh();
  bindResizeBreakpointRefresh();

  const handleShopifySectionEvent = (event) => {
    if (!shouldRefreshForSectionEvent(event)) {
      return;
    }
    if (
      event &&
      typeof event.type === "string" &&
      (event.type === "shopify:section:unload" || event.type === "shopify:block:unload")
    ) {
      cleanupFadeStateForEvent(event);
    }
    scheduleRefresh();
  };

  document.addEventListener("shopify:section:load", handleShopifySectionEvent);
  document.addEventListener("shopify:section:reorder", handleShopifySectionEvent);
  document.addEventListener("shopify:section:unload", handleShopifySectionEvent);
  document.addEventListener("shopify:section:select", handleShopifySectionEvent);
  document.addEventListener("shopify:section:deselect", handleShopifySectionEvent);
  document.addEventListener("shopify:block:load", handleShopifySectionEvent);
  document.addEventListener("shopify:block:reorder", handleShopifySectionEvent);
  document.addEventListener("shopify:block:unload", handleShopifySectionEvent);
  document.addEventListener("shopify:block:select", handleShopifySectionEvent);
  document.addEventListener("shopify:block:deselect", handleShopifySectionEvent);
})();

/* NDT Shopify embed: russian-support modal (source) */
(() => {
  const GLOBAL_KEY = "__ndtRussianSupportRuntime";
  if (window[GLOBAL_KEY]) {
    return;
  }
  window[GLOBAL_KEY] = true;

  const ENDPOINT = "https://tilda.quality-ndt.com/contact/russian";
  const LINK_ATTR = "data-ndt-russian-link";
  const MENU_SELECTOR = ".announcement-bar__text";

  const COPY = {
    linkLabel: "We speak Russian",
    title: "Мы говорим по-русски / We speak Russian",
    subtitle:
      "Напишите нам по-русски — ответим на русском. / Write to us in Russian — we will reply in Russian.",
    nameLabel: "Имя / Name",
    emailLabel: "Email",
    messageLabel: "Сообщение / Message",
    submit: "Отправить / Send",
    sending: "Отправка… / Sending…",
    success: "Спасибо! Мы свяжемся с вами. / Thank you! We will get back to you.",
    invalid: "Проверьте поля формы. / Please check the form fields.",
    nameRequired: "Укажите имя. / Please enter your name.",
    emailInvalid: "Укажите корректный email. / Please enter a valid email.",
    messageShort: "Сообщение слишком короткое (мин. 10 символов). / Message is too short (min 10 characters).",
    throttled: "Слишком много запросов — попробуйте позже. / Too many requests — please try later.",
    failed: "Не удалось отправить. Попробуйте позже. / Could not send. Please try again later.",
    close: "Close"
  };

  let modal = null;
  let lastTrigger = null;

  const buildModal = () => {
    if (modal) {
      return modal;
    }
    modal = document.createElement("div");
    modal.className = "ndt-russian-modal";
    modal.setAttribute("aria-hidden", "true");
    modal.innerHTML =
      '<div class="ndt-russian-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="ndt-russian-modal-title">' +
      '<button class="ndt-russian-modal__close" type="button" aria-label="' + COPY.close + '">&times;</button>' +
      '<h3 class="ndt-russian-modal__title" id="ndt-russian-modal-title">' + COPY.title + "</h3>" +
      '<p class="ndt-russian-modal__subtitle">' + COPY.subtitle + "</p>" +
      '<form class="ndt-russian-modal__form" novalidate>' +
      '<label class="ndt-russian-modal__label">' + COPY.nameLabel +
      '<input class="ndt-russian-modal__input" name="name" type="text" maxlength="100" required></label>' +
      '<label class="ndt-russian-modal__label">' + COPY.emailLabel +
      '<input class="ndt-russian-modal__input" name="email" type="email" maxlength="200" required></label>' +
      '<label class="ndt-russian-modal__label">' + COPY.messageLabel +
      '<textarea class="ndt-russian-modal__input ndt-russian-modal__textarea" name="message" maxlength="4000" required></textarea></label>' +
      '<div class="ndt-russian-modal__hp" aria-hidden="true">' +
      '<input name="website" type="text" tabindex="-1" autocomplete="off"></div>' +
      '<button class="ndt-russian-modal__submit" type="submit">' + COPY.submit + "</button>" +
      '<p class="ndt-russian-modal__status" role="status" aria-live="polite"></p>' +
      "</form></div>";
    document.body.appendChild(modal);

    const form = modal.querySelector("form");
    const status = modal.querySelector(".ndt-russian-modal__status");
    const submitButton = modal.querySelector(".ndt-russian-modal__submit");

    const setStatus = (text, kind) => {
      status.textContent = text || "";
      status.classList.toggle("is-error", kind === "error");
      status.classList.toggle("is-success", kind === "success");
    };

    modal.addEventListener("click", (event) => {
      if (event.target === modal || event.target.closest(".ndt-russian-modal__close")) {
        closeModal();
      }
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && modal.classList.contains("is-open")) {
        closeModal();
      }
    });

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const name = form.elements.name.value.trim();
      const email = form.elements.email.value.trim();
      const message = form.elements.message.value.trim();
      const emailValid = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
      if (!name) {
        setStatus(COPY.nameRequired, "error");
        form.elements.name.focus();
        return;
      }
      if (!emailValid) {
        setStatus(COPY.emailInvalid, "error");
        form.elements.email.focus();
        return;
      }
      if (message.length < 10) {
        setStatus(COPY.messageShort, "error");
        form.elements.message.focus();
        return;
      }
      submitButton.disabled = true;
      submitButton.textContent = COPY.sending;
      setStatus("", null);
      fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: name,
          email: email,
          message: message,
          website: form.elements.website.value
        })
      })
        .then((response) => {
          if (response.ok) {
            form.reset();
            setStatus(COPY.success, "success");
            return;
          }
          if (response.status === 429) {
            setStatus(COPY.throttled, "error");
            return;
          }
          if (response.status === 422) {
            setStatus(COPY.invalid, "error");
            return;
          }
          setStatus(COPY.failed, "error");
        })
        .catch(() => {
          setStatus(COPY.failed, "error");
        })
        .finally(() => {
          submitButton.disabled = false;
          submitButton.textContent = COPY.submit;
        });
    });

    return modal;
  };

  const openModal = (trigger) => {
    lastTrigger = trigger || null;
    const node = buildModal();
    node.classList.add("is-open");
    node.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    const firstInput = node.querySelector('input[name="name"]');
    if (firstInput) {
      firstInput.focus();
    }
  };

  const closeModal = () => {
    if (!modal) {
      return;
    }
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    if (lastTrigger && typeof lastTrigger.focus === "function") {
      lastTrigger.focus();
    }
  };

  const injectLink = () => {
    const menu = document.querySelector(MENU_SELECTOR);
    if (!menu || menu.querySelector("[" + LINK_ATTR + "]")) {
      return;
    }
    const link = document.createElement("a");
    link.href = "#";
    link.setAttribute(LINK_ATTR, "");
    link.setAttribute("title", COPY.linkLabel);
    link.innerHTML = "<strong>" + COPY.linkLabel + "</strong>";
    link.addEventListener("click", (event) => {
      event.preventDefault();
      openModal(link);
    });
    menu.appendChild(link);
  };

  const boot = () => {
    injectLink();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
  window.addEventListener("pageshow", injectLink);
  document.addEventListener("shopify:section:load", injectLink);
})();

/* NDT per-variant description swap (product pages).
   Content comes from the "Custom liquid" block documented in
   shopify/handoff/custom-liquid-variant-description.liquid: it server-renders
   the selected variant's rich-text metafield (custom.variant_description) into
   [data-ndt-variant-desc] and embeds an {variant id -> html} map as JSON.
   Horizon only morphs the <variant-picker> itself on a variant click, so this
   runtime does the swap: instantly on the radio click (no network wait) and
   authoritatively on the theme's bubbling variant:update event. */
(() => {
  const GLOBAL_KEY = "__ndtVariantDescRuntime";
  if (window[GLOBAL_KEY]) {
    return;
  }

  const WRAPPER_SELECTOR = "[data-ndt-variant-desc]";
  const MAP_ATTRIBUTE = "data-ndt-variant-desc-map";
  const CURRENT_ATTRIBUTE = "data-ndt-current-variant";

  /* Pure swap decision: null = leave the DOM untouched (no usable map/id),
     otherwise { html, show } for the wrapper. Map keys are strings because the
     Liquid block writes them quoted; variant ids may arrive as numbers. */
  const resolveVariantDescription = (map, variantId) => {
    if (!map || typeof map !== "object" || Array.isArray(map)) {
      return null;
    }
    if (variantId === null || variantId === undefined || variantId === "") {
      return null;
    }
    const html = map[String(variantId)];
    if (typeof html !== "string" || html.trim() === "") {
      return { html: "", show: false };
    }
    return { html: html, show: true };
  };

  const readMap = (productId) => {
    if (!productId) {
      return null;
    }
    const node = document.querySelector(
      "script[" + MAP_ATTRIBUTE + '="' + productId + '"]'
    );
    if (!node) {
      return null;
    }
    try {
      return JSON.parse(node.textContent || "");
    } catch (error) {
      return null;
    }
  };

  const apply = (variantId, productId) => {
    const wrapper = document.querySelector(WRAPPER_SELECTOR);
    if (!wrapper) {
      return;
    }
    const wrapperProductId = wrapper.getAttribute("data-ndt-variant-desc") || "";
    if (productId && String(productId) !== wrapperProductId) {
      /* Change came from another product's picker (quick-add dialog etc.). */
      return;
    }
    const resolved = resolveVariantDescription(readMap(wrapperProductId), variantId);
    if (!resolved) {
      return;
    }
    if (wrapper.getAttribute(CURRENT_ATTRIBUTE) === String(variantId)) {
      return;
    }
    wrapper.setAttribute(CURRENT_ATTRIBUTE, String(variantId));
    wrapper.innerHTML = resolved.html;
    wrapper.hidden = !resolved.show;
  };

  /* Fast path: the radio click itself, before Horizon's section fetch lands.
     Horizon stamps data-variant-id on each variant-picker input. */
  document.addEventListener("change", (event) => {
    const input = event.target;
    if (!input || !input.dataset || !input.dataset.variantId) {
      return;
    }
    const picker =
      typeof input.closest === "function" ? input.closest("variant-picker") : null;
    if (!picker) {
      return;
    }
    apply(input.dataset.variantId, picker.dataset ? picker.dataset.productId || "" : "");
  });

  /* Authoritative path: Horizon dispatches variant:update (bubbles) after the
     section fetch with detail.resource = the resolved variant JSON. */
  document.addEventListener("variant:update", (event) => {
    const detail = event ? event.detail : null;
    if (!detail || !detail.resource || detail.resource.id === undefined || detail.resource.id === null) {
      return;
    }
    apply(
      detail.resource.id,
      detail.data && detail.data.productId ? detail.data.productId : ""
    );
  });

  /* Deep links, bfcache restores, and theme-editor section reloads. The block
     already server-renders the selected variant, so this is a cheap reconcile
     (the CURRENT_ATTRIBUTE no-op guard usually short-circuits it). */
  const syncFromLocation = () => {
    let variantId = "";
    try {
      variantId = new URL(window.location.href).searchParams.get("variant") || "";
    } catch (error) {
      variantId = "";
    }
    if (variantId) {
      apply(variantId, "");
    }
  };
  window.addEventListener("pageshow", syncFromLocation);
  document.addEventListener("shopify:section:load", syncFromLocation);

  window[GLOBAL_KEY] = {
    version: 1,
    apply: apply,
    resolveVariantDescription: resolveVariantDescription,
  };
})();

/* NDT product-card variant buttons.
   Horizon renders no variant picker inside a product card, so on a collection /
   product-list page a shopper cannot see or pick the variant (Level 1 / Level 2
   / Level 3 / Practice ...) without opening the product. This runtime injects it
   into every product card that has 2+ variants, between the card title and the
   price, and makes a click select the variant IN THE CARD: price, compare-at
   price, add-to-cart target and the card links all follow it, with no page load.
   The option labels are not in the card markup, so they come from
   /products/<handle>.js — fetched lazily when the card nears the viewport and
   cached per handle for the session. Cards that Horizon re-renders lose the
   injected row; the scan pass re-injects it from cache without a new request. */
(() => {
  const GLOBAL_KEY = "__ndtCardVariantsRuntime";
  if (window[GLOBAL_KEY]) {
    return;
  }

  const RUNTIME_VERSION = 15;
  const ROW_CLASS = "ndt-card-variants";
  const BUTTON_CLASS = "ndt-card-variants__btn";
  const SELECTED_CLASS = "is-selected";
  /* Level 3 is not sellable yet (operator 2026-07-31): its button renders
     dimmed via SOON_CLASS and aria-disabled - NOT natively disabled, so hover
     and click still reach it and surface the "Soon" bubble; a click never
     selects. Matched on the variant title so it covers every course card. */
  const SOON_CLASS = "is-soon";
  const SOON_FLASH_CLASS = "ndt-soon-flash";
  const SOON_TITLE_PATTERN = /^level\s*3$/i;
  const SOON_LABEL = "Soon";
  /* The product page renders Horizon's own <variant-picker>: those option
     radios are the theme's markup, not ours, and stayed selectable while the
     card button for the SAME option refused the click. The gate below covers
     them from here rather than from a second module, so the two surfaces can
     never disagree about which option is "Soon". */
  const PICKER_TAG = "variant-picker";
  const COURSE_PICKER_LABEL = "Choose your training option";
  const COURSE_PICKER_PATH = /\/products\/(?:liquid-penetrant-testing|magnetic-particle-testing|radiographic-testing|thermal-infrared-testing|ultrasonic-testing|visual-testing)\.js$/;
  const PICKER_LABEL_CLASS = "variant-option__button-label";
  const PICKER_BUBBLE_CLASS = "ndt-variant-soon";
  const SOON_FLAG = "data-ndt-soon";
  const CARD_FLAG = "data-ndt-card-variants";
  const SAMPLE_ATTRIBUTE = "data-ndt-money-sample";
  const CACHE_PREFIX = "ndt:cardVariants:v2:";
  /* Option values get renamed in Admin, so a cached label must expire on its
     own; without this a rename stayed invisible for the whole browser session
     (sessionStorage survives reloads, including a hard refresh). */
  const CACHE_TTL_MS = 300000;
  const DESC_CLASS = "ndt-card-variants-desc";
  const DESC_ATTRIBUTE = "data-ndt-card-variant-desc";
  const DESC_MAP_ATTRIBUTE = "data-ndt-card-variant-desc-map";
  const HINT_CLASS = "ndt-card-variants-hint";
  const HINT_ATTRIBUTE = "data-ndt-card-hint";
  const HINT_LABEL = "Select the product to continue...";
  const DETAIL_ROW_CLASS = "ndt-card-actions";
  const DETAIL_CLASS = "ndt-card-actions__detail";
  const DETAIL_ATTRIBUTE = "data-ndt-card-detail";
  const DETAIL_LABEL = "Detailed information about the course";

  /* ---- pure helpers (unit-tested in tests/card_variant_buttons_test.js) ---- */

  /* Card link -> product JSON endpoint; "" means "not a usable product URL". */
  const productJsonPath = (productUrl) => {
    if (typeof productUrl !== "string") {
      return "";
    }
    const path = productUrl.trim().split("#")[0].split("?")[0].replace(/\/+$/, "");
    const marker = path.indexOf("/products/");
    if (marker === -1) {
      return "";
    }
    const handle = path.slice(marker + 10);
    if (handle === "" || handle.indexOf("/") !== -1) {
      return "";
    }
    return path.slice(-3) === ".js" ? path : path + ".js";
  };

  /* Rewrite ?variant= on a card link without disturbing the other params. */
  const withVariantParam = (url, variantId) => {
    if (typeof url !== "string" || url === "") {
      return url;
    }
    if (variantId === null || variantId === undefined || variantId === "") {
      return url;
    }
    const hashAt = url.indexOf("#");
    const hash = hashAt === -1 ? "" : url.slice(hashAt);
    const base = hashAt === -1 ? url : url.slice(0, hashAt);
    const queryAt = base.indexOf("?");
    const head = queryAt === -1 ? base : base.slice(0, queryAt);
    const kept = [];
    if (queryAt !== -1) {
      base.slice(queryAt + 1).split("&").forEach((pair) => {
        if (pair !== "" && pair.split("=")[0] !== "variant") {
          kept.push(pair);
        }
      });
    }
    kept.push("variant=" + String(variantId));
    return head + "?" + kept.join("&") + hash;
  };

  /* /products/<handle>.js payload -> { variants: [...] }. null = render nothing
     (single-variant product, malformed payload, or no labelable variants). */
  const buildVariantModel = (productJson) => {
    if (!productJson || typeof productJson !== "object" || Array.isArray(productJson)) {
      return null;
    }
    const raw = productJson.variants;
    if (!Array.isArray(raw) || raw.length < 2) {
      return null;
    }
    const variants = [];
    raw.forEach((item) => {
      if (!item || typeof item !== "object") {
        return;
      }
      if (item.id === null || item.id === undefined || item.id === "") {
        return;
      }
      let label = typeof item.title === "string" ? item.title.trim() : "";
      if (label === "" || label === "Default Title") {
        label = typeof item.option1 === "string" ? item.option1.trim() : "";
      }
      if (label === "") {
        return;
      }
      variants.push({
        id: String(item.id),
        label: label,
        available: item.available !== false,
        price: typeof item.price === "number" ? item.price : null,
        compareAtPrice: typeof item.compare_at_price === "number" ? item.compare_at_price : null,
      });
    });
    return variants.length < 2 ? null : { variants: variants };
  };

  /* Reformat cents in the exact shape the card already renders ("$320.00" ->
     "$540.00", "320,00 EUR-style" -> same separators). A leading word ("From ")
     is dropped; a currency code glued to the amount ("US$") is kept. */
  const formatMoneyLike = (sample, cents) => {
    if (typeof cents !== "number" || !isFinite(cents)) {
      return "";
    }
    const units = Math.round(Math.abs(cents)) / 100;
    const sign = cents < 0 ? "-" : "";
    if (typeof sample !== "string") {
      return sign + units.toFixed(2);
    }
    const match = sample.match(/\d[\d.,\u00a0\u202f ]*\d|\d/);
    if (!match) {
      return sign + units.toFixed(2);
    }
    const number = match[0];
    const prefix = sample.slice(0, match.index).replace(/[A-Za-z\u0400-\u04ff]+\s+/g, "");
    const suffix = sample.slice(match.index + number.length);
    const hasDecimals = /[.,]\d{2}$/.test(number);
    const decimalSeparator = hasDecimals ? number.charAt(number.length - 3) : "";
    const groupSeparator = decimalSeparator === "," ? "." : ",";
    const rounded = hasDecimals ? units.toFixed(2) : String(Math.round(units));
    const parts = rounded.split(".");
    const grouped = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
    const body = hasDecimals ? grouped + decimalSeparator + parts[1] : grouped;
    return sign + prefix + body + suffix;
  };

  /* Variant id -> short card description; "" means "show nothing". Values are
     plain text (the metafield is a text field and the node is filled with
     textContent), keys are strings because the Liquid block quotes them. */
  const resolveCardDescription = (map, variantId) => {
    if (!map || typeof map !== "object" || Array.isArray(map)) {
      return "";
    }
    if (variantId === null || variantId === undefined || variantId === "") {
      return "";
    }
    const text = map[String(variantId)];
    return typeof text === "string" ? text.trim() : "";
  };

  /* Whether any variant of this product carries a description: decides if the
     card gets a description slot at all (kept self-contained so the slot logic
     stays unit-testable). */
  const anyVariantDescribed = (model, map) => {
    if (!model || !map || typeof map !== "object" || Array.isArray(map)) {
      return false;
    }
    for (let index = 0; index < model.variants.length; index += 1) {
      const text = map[String(model.variants[index].id)];
      if (typeof text === "string" && text.trim() !== "") {
        return true;
      }
    }
    return false;
  };

  /* Stored entry -> model, or null when missing, malformed, of an older shape,
     stamped in the future (clock skew), or older than the TTL. */
  const unpackCacheEntry = (raw, nowMs, ttlMs) => {
    if (typeof raw !== "string" || raw === "") {
      return null;
    }
    let entry = null;
    try {
      entry = JSON.parse(raw);
    } catch (error) {
      return null;
    }
    if (!entry || typeof entry !== "object" || Array.isArray(entry)) {
      return null;
    }
    if (typeof entry.at !== "number" || !isFinite(entry.at)) {
      return null;
    }
    if (typeof nowMs === "number" && isFinite(nowMs) && typeof ttlMs === "number") {
      const age = nowMs - entry.at;
      if (age < 0 || age > ttlMs) {
        return null;
      }
    }
    const model = entry.model;
    if (!model || typeof model !== "object" || Array.isArray(model)) {
      return null;
    }
    if (!Array.isArray(model.variants) || model.variants.length < 2) {
      return null;
    }
    return model;
  };

  /* ---- product JSON cache ---- */

  const MEMORY = new Map();
  const PENDING = new Map();
  const MODELS = new WeakMap();
  const OBSERVED = new WeakSet();

  const readCache = (jsonPath) => {
    try {
      return unpackCacheEntry(
        window.sessionStorage.getItem(CACHE_PREFIX + jsonPath),
        Date.now(),
        CACHE_TTL_MS
      );
    } catch (error) {
      /* Private mode / disabled storage: the in-memory cache still applies. */
      return null;
    }
  };

  const writeCache = (jsonPath, model) => {
    try {
      window.sessionStorage.setItem(
        CACHE_PREFIX + jsonPath,
        JSON.stringify({ at: Date.now(), model: model })
      );
    } catch (error) {
      /* Quota or disabled storage: not fatal, skip persisting. */
    }
  };

  const loadModel = (jsonPath) => {
    if (MEMORY.has(jsonPath)) {
      return Promise.resolve(MEMORY.get(jsonPath));
    }
    const cached = readCache(jsonPath);
    if (cached) {
      MEMORY.set(jsonPath, cached);
      return Promise.resolve(cached);
    }
    if (PENDING.has(jsonPath)) {
      return PENDING.get(jsonPath);
    }
    if (typeof window.fetch !== "function") {
      MEMORY.set(jsonPath, null);
      return Promise.resolve(null);
    }
    const pending = window
      .fetch(jsonPath, {
        credentials: "same-origin",
        cache: "no-cache",
        headers: { Accept: "application/json" },
      })
      .then((response) => (response && response.ok ? response.json() : null))
      .then((payload) => {
        const model = buildVariantModel(payload);
        MEMORY.set(jsonPath, model);
        if (model) {
          writeCache(jsonPath, model);
        }
        PENDING.delete(jsonPath);
        return model;
      })
      .catch(() => {
        /* Network or parse failure: remember the miss, do not retry this card. */
        MEMORY.set(jsonPath, null);
        PENDING.delete(jsonPath);
        return null;
      });
    PENDING.set(jsonPath, pending);
    return pending;
  };

  /* ---- card DOM ---- */

  const cardProductUrl = (card) => {
    const link =
      card.querySelector('a[ref="productCardLink"]') ||
      card.querySelector('a[ref="cardGalleryLink"]') ||
      card.querySelector('a[ref="productTitleLink"]') ||
      card.querySelector('a[href*="/products/"]');
    if (link) {
      return link.getAttribute("href") || "";
    }
    const pickup = card.querySelector("local-pickup[data-product-url]");
    return pickup ? pickup.getAttribute("data-product-url") || "" : "";
  };

  /* Cheap pre-filter: Horizon stamps the variants its product form can submit
     on the accelerated-checkout element, so a single-variant card is skipped
     without a network call. -1 = undecided (element absent), ask the JSON
     endpoint. Assumes that list holds every variant, sold out ones included; if
     Shopify ever narrows it to purchasable variants, a product with exactly one
     purchasable variant would be skipped (cards then look as they did before
     this runtime, so it degrades rather than breaks). */
  const cardVariantCount = (card) => {
    const node = card.querySelector("shopify-accelerated-checkout[variant-params]");
    if (!node) {
      return -1;
    }
    try {
      const parsed = JSON.parse(node.getAttribute("variant-params") || "");
      return Array.isArray(parsed) ? parsed.length : -1;
    } catch (error) {
      return -1;
    }
  };

  /* The quick-add markup inside the gallery carries its own price and variant
     nodes; the row belongs to the card body, so gallery-scoped nodes are out. */
  const outsideGallery = (node) => {
    return !node.closest('[ref="cardGallery"], .card-gallery, quick-add-component');
  };

  let descriptionMap = null;

  /* One page-level map, emitted by the Custom liquid block
     (shopify/handoff/custom-liquid-card-variant-descriptions.liquid). Absent
     block -> no descriptions anywhere, buttons still work. */
  const readDescriptionMap = () => {
    if (descriptionMap) {
      return descriptionMap;
    }
    const nodes = document.querySelectorAll("script[" + DESC_MAP_ATTRIBUTE + "]");
    if (nodes.length === 0) {
      return null;
    }
    const merged = {};
    let filled = false;
    for (let index = 0; index < nodes.length; index += 1) {
      try {
        const parsed = JSON.parse(nodes[index].textContent || "");
        if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
          Object.keys(parsed).forEach((key) => {
            merged[key] = parsed[key];
            filled = true;
          });
        }
      } catch (error) {
        /* One malformed block must not blank out the others. */
      }
    }
    descriptionMap = filled ? merged : null;
    return descriptionMap;
  };

  const cardPriceNode = (card) => {
    const nodes = card.querySelectorAll("product-price");
    for (let index = 0; index < nodes.length; index += 1) {
      if (outsideGallery(nodes[index])) {
        return nodes[index];
      }
    }
    return null;
  };

  const currentVariantId = (card) => {
    const input = card.querySelector('input[ref="variantId"]');
    if (input && input.value) {
      return String(input.value);
    }
    const link = card.querySelector('a[href*="variant="]');
    const match = link ? (link.getAttribute("href") || "").match(/[?&]variant=(\d+)/) : null;
    return match ? match[1] : "";
  };

  /* Shopify Markets can render a card price in a converted presentment currency
     while /products/<handle>.js reports shop-currency cents; rewriting the price
     then shows a WRONG number. Skip price updates on a converted rate - buttons,
     links, description and cart target still switch. Absent Shopify.currency ->
     treat as the shop currency (unchanged behaviour). */
  const currencyIsConverted = () => {
    const shopify = window.Shopify;
    const currency = shopify && shopify.currency ? shopify.currency : null;
    if (!currency || currency.rate === undefined || currency.rate === null) {
      return false;
    }
    const rate = Number(currency.rate);
    return isFinite(rate) && rate !== 1;
  };

  const applyPrice = (card, priceCents, compareCents) => {
    if (currencyIsConverted()) {
      return;
    }
    const holder = cardPriceNode(card);
    if (!holder) {
      return;
    }
    const priceNode = holder.querySelector(".price");
    if (priceNode && priceCents !== null) {
      if (!priceNode.hasAttribute(SAMPLE_ATTRIBUTE)) {
        priceNode.setAttribute(SAMPLE_ATTRIBUTE, priceNode.textContent || "");
      }
      priceNode.textContent = formatMoneyLike(priceNode.getAttribute(SAMPLE_ATTRIBUTE), priceCents);
    }
    if (priceCents === null) {
      /* No price data for this variant: leave what the server rendered alone
         instead of hiding its compare-at price. */
      return;
    }
    const compareNode = holder.querySelector(".compare-at-price");
    if (!compareNode) {
      return;
    }
    if (!compareNode.hasAttribute(SAMPLE_ATTRIBUTE)) {
      compareNode.setAttribute(SAMPLE_ATTRIBUTE, compareNode.textContent || "");
    }
    const group = compareNode.closest('[role="group"]') || compareNode;
    if (compareCents !== null && priceCents !== null && compareCents > priceCents) {
      compareNode.textContent = formatMoneyLike(
        compareNode.getAttribute(SAMPLE_ATTRIBUTE),
        compareCents
      );
      group.style.display = "";
    } else {
      group.style.display = "none";
    }
  };

  const readCents = (button, name) => {
    if (!button.hasAttribute(name)) {
      return null;
    }
    const value = Number(button.getAttribute(name));
    return isFinite(value) ? value : null;
  };

  const CART_SYNCS = new WeakMap();
  const CART_STATE_ATTRIBUTE = "data-ndt-card-cart-state";

  /* Shared by product cards and native product forms. Retargeting the variant
     ID does not update Horizon's data-cart-quantity.
     Read the current session cart before allowing the newly selected variant
     to submit. Never assume zero: it may already be in this cart on page load. */
  const syncCardCartQuantity = (card) => {
    if (!card.querySelector("quantity-selector-component[data-variant-id]")) {
      return;
    }
    const previous = CART_SYNCS.get(card);
    const state = {
      buttons: previous ? previous.buttons.map((entry) => ({
        button: entry.button,
        disabled: entry.disabled && entry.button.disabled,
      })) : Array.from(
        card.querySelectorAll('[ref="addToCartButton"]'),
        (button) => ({ button: button, disabled: button.disabled })
      ),
      controller: new AbortController(),
    };
    CART_SYNCS.set(card, state);
    if (previous) {
      previous.controller.abort();
    }
    card.setAttribute(CART_STATE_ATTRIBUTE, "pending");
    state.buttons.forEach((entry) => { entry.button.disabled = true; });
    const timeout = window.setTimeout(() => state.controller.abort(), 10000);
    window.fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store",
      headers: { Accept: "application/json" },
      signal: state.controller.signal,
    }).then((response) => {
      if (!response.ok) {
        throw new Error("http_" + response.status);
      }
      return response.json();
    }).then((cart) => {
      if (!cart || !Array.isArray(cart.items) || cart.items.length > 1000) {
        throw new Error("invalid_cart");
      }
      const quantities = new Map();
      cart.items.forEach((item) => {
        if (!item || !/^[0-9]{1,20}$/.test(String(item.variant_id)) ||
            !Number.isSafeInteger(item.quantity) || item.quantity < 0 || item.quantity > 1000000) {
          throw new Error("invalid_cart");
        }
        const id = String(item.variant_id);
        quantities.set(id, (quantities.get(id) || 0) + item.quantity);
      });
      if (CART_SYNCS.get(card) !== state || state.superseded || !card.isConnected) {
        return;
      }
      card.querySelectorAll("quantity-selector-component[data-variant-id]").forEach((selector) => {
        /* Native variant:update updates the form input but can leave BOTH the
           selector identity and cart quantity on the previously chosen level. */
        const form = selector.closest("product-form-component");
        const variantInput = form && form.querySelector('input[name="id"]');
        const variantId = variantInput && variantInput.value
          ? variantInput.value : selector.getAttribute("data-variant-id");
        selector.setAttribute("data-variant-id", variantId);
        const quantity = quantities.get(variantId) || 0;
        if (typeof selector.setCartQuantity === "function") {
          selector.setCartQuantity(quantity);
        } else {
          /* The theme custom element may not have upgraded yet. Its public
             method reads this same attribute when it becomes available. */
          const input = selector.querySelector('input[name="quantity"]');
          if (input) {
            input.setAttribute("data-cart-quantity", String(quantity));
          }
        }
      });
      const error = card.querySelector("[data-ndt-card-cart-error]");
      if (error) {
        error.remove();
      }
      card.removeAttribute(CART_STATE_ATTRIBUTE);
      CART_SYNCS.delete(card);
      /* Only release disables owned by this refresh. Horizon's duplicate-error
         timer may already have released a pre-existing disable while we waited;
         restoring that old true value would leave an allowed level stuck. */
      state.buttons.forEach((entry) => {
        if (!entry.disabled) {
          entry.button.disabled = false;
        }
      });
    }).catch((error) => {
      if (CART_SYNCS.get(card) !== state || state.superseded || !card.isConnected) {
        return;
      }
      const code = /^(http_[0-9]{3}|invalid_cart)$/.test(error.message)
        ? error.message : "request_failed";
      console.error("NDT card cart quantity sync failed", code);
      card.setAttribute(CART_STATE_ATTRIBUTE, "error");
      let message = card.querySelector("[data-ndt-card-cart-error]");
      if (!message) {
        message = document.createElement("p");
        message.setAttribute("data-ndt-card-cart-error", "");
        message.setAttribute("role", "alert");
        (card.querySelector(".buy-buttons-block") || card).appendChild(message);
      }
      message.textContent = card.matches("product-card")
        ? "Unable to check your cart. Select the course level again to retry."
        : "Unable to check your cart. Choose a different course level, then try again.";
    }).finally(() => window.clearTimeout(timeout));
  };

  /* Disabled buttons do not cover Enter or requestSubmit(). Keep Horizon's
     own submit handler from running against stale quantities in either case. */
  document.addEventListener("submit", (event) => {
    const target = event.target;
    const card = target && typeof target.closest === "function"
      ? target.closest("[" + CART_STATE_ATTRIBUTE + "]") : null;
    if (card) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener("cart:update", () => {
    document.querySelectorAll('[' + CART_STATE_ATTRIBUTE + '="pending"]')
      .forEach((scope) => {
        const state = CART_SYNCS.get(scope);
        if (!state || !state.superseded) {
          syncCardCartQuantity(scope);
        }
      });
  });

  /* Horizon refreshes cart quantities on variant:update only for forms with
     quantity rules or volume pricing. Ordinary course forms need the same
     reconciliation as cards, after the native handler resolves the variant.
     Match its nearest event scope and product ID; never touch another section. */
  const nativeVariantForms = (event) => {
    const target = event.target;
    if (!target || typeof target.closest !== "function") {
      return [];
    }
    const scope = target.closest(".shopify-section, dialog, product-card");
    const picker = target.closest("variant-picker");
    const data = event.detail && event.detail.data;
    const productId = String((data && (data.newProduct ? data.newProduct.id : data.productId)) ||
      (picker && picker.dataset.productId) || "");
    if (!scope || !productId) {
      return [];
    }
    return Array.from(scope.querySelectorAll("product-form-component")).filter((form) =>
      form.dataset.productId === productId && form.querySelector("quantity-selector-component")
    );
  };
  document.addEventListener("variant:selected", (event) => {
    nativeVariantForms(event).forEach((form) => {
      const scope = form.closest("product-card") || form;
      const state = CART_SYNCS.get(scope);
      if (state) {
        state.superseded = true;
        state.controller.abort();
      }
    });
  });
  document.addEventListener("variant:update", (event) => {
    const variant = event.detail && event.detail.resource;
    nativeVariantForms(event).forEach((form) => {
      const scope = form.closest("product-card") || form;
      if (!variant || !variant.id || variant.available === false) {
        const state = CART_SYNCS.get(scope);
        if (state) {
          state.controller.abort();
          CART_SYNCS.delete(scope);
          scope.removeAttribute(CART_STATE_ATTRIBUTE);
        }
        return;
      }
      const input = form.querySelector('input[name="id"]');
      if (input && input.value === String(variant.id)) {
        syncCardCartQuantity(scope);
      }
    });
  });

  const applyVariant = (card, button) => {
    const variantId = button.getAttribute("data-ndt-variant-id") || "";
    if (variantId === "") {
      return;
    }
    const buttons = card.querySelectorAll("." + BUTTON_CLASS);
    for (let index = 0; index < buttons.length; index += 1) {
      const selected = buttons[index] === button;
      buttons[index].classList.toggle(SELECTED_CLASS, selected);
      buttons[index].setAttribute("aria-pressed", selected ? "true" : "false");
    }
    const inputs = card.querySelectorAll('input[ref="variantId"]');
    for (let index = 0; index < inputs.length; index += 1) {
      if (!inputs[index].closest("variant-picker")) {
        inputs[index].value = variantId;
      }
    }
    const stamped = card.querySelectorAll(
      "quantity-selector-component[data-variant-id], local-pickup[data-variant-id]"
    );
    for (let index = 0; index < stamped.length; index += 1) {
      stamped[index].setAttribute("data-variant-id", variantId);
    }
    const links = card.querySelectorAll('a[href*="/products/"]');
    for (let index = 0; index < links.length; index += 1) {
      links[index].setAttribute(
        "href",
        withVariantParam(links[index].getAttribute("href") || "", variantId)
      );
    }
    applyPrice(card, readCents(button, "data-ndt-price"), readCents(button, "data-ndt-compare"));
    const description = card.querySelector("[" + DESC_ATTRIBUTE + "]");
    if (description) {
      const text = resolveCardDescription(readDescriptionMap(), variantId);
      description.textContent = text;
      description.style.display = text === "" ? "none" : "";
    }
    card.setAttribute("data-ndt-selected-variant", variantId);
    syncCardCartQuantity(card);
  };

  const buildRow = (model, selectedId) => {
    const row = document.createElement("div");
    row.className = ROW_CLASS;
    row.setAttribute("role", "group");
    row.setAttribute("aria-label", "Select an option");
    model.variants.forEach((variant) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = BUTTON_CLASS;
      button.textContent = variant.label;
      button.setAttribute("data-ndt-variant-id", variant.id);
      if (typeof variant.price === "number") {
        button.setAttribute("data-ndt-price", String(variant.price));
      }
      if (typeof variant.compareAtPrice === "number") {
        button.setAttribute("data-ndt-compare", String(variant.compareAtPrice));
      }
      if (!variant.available) {
        button.disabled = true;
        button.setAttribute("aria-disabled", "true");
        button.title = "Unavailable";
      } else if (SOON_TITLE_PATTERN.test((variant.label || "").trim())) {
        /* Soft-disabled: keep pointer events (a native disabled button swallows
           hover in some engines), block selection in the click handler. */
        button.classList.add(SOON_CLASS);
        button.setAttribute("aria-disabled", "true");
        button.title = SOON_LABEL;
      }
      const selected = String(selectedId) === variant.id;
      button.setAttribute("aria-pressed", selected ? "true" : "false");
      if (selected) {
        button.classList.add(SELECTED_CLASS);
      }
      row.appendChild(button);
    });
    return row;
  };

  const buildDescription = (text) => {
    const node = document.createElement("div");
    node.className = DESC_CLASS;
    node.setAttribute(DESC_ATTRIBUTE, "");
    node.textContent = text;
    node.style.display = text === "" ? "none" : "";
    return node;
  };

  /* Static prompt for the button row below it. Tied to the ROW, not to the
     description: it tells the visitor to pick a variant, so it belongs on every
     card that has buttons - including one whose variants carry no blurb - and on
     none that has no buttons to press. */
  const buildHint = () => {
    const node = document.createElement("div");
    node.className = HINT_CLASS;
    node.setAttribute(HINT_ATTRIBUTE, "");
    node.textContent = HINT_LABEL;
    return node;
  };

  /* "Read more" reuses the thumbnail's own URL. applyVariant rewrites every
     /products/ link in the card, so this one follows the selected variant. */
  const cardGalleryHref = (card) => {
    const link =
      card.querySelector('a[ref="cardGalleryLink"]') ||
      card.querySelector('a[ref="productCardLink"]') ||
      card.querySelector('a[ref="productTitleLink"]');
    const href = link ? link.getAttribute("href") || "" : "";
    return href !== "" ? href : cardProductUrl(card);
  };

  const cardTitleText = (card) => {
    const title =
      card.querySelector('a[ref="productTitleLink"] p') ||
      card.querySelector('a[ref="productTitleLink"]') ||
      card.querySelector("h3");
    return title ? (title.textContent || "").trim() : "";
  };

  const cardAddToCartButton = (card) =>
    card.querySelector(
      '.buy-buttons-block .product-form-buttons button[ref="addToCartButton"]'
    ) ||
    card.querySelector(
      ".buy-buttons-block .product-form-buttons button.add-to-cart-button"
    );

  const buildDetailButton = (card) => {
    const href = cardGalleryHref(card);
    if (href === "") {
      return null;
    }
    const link = document.createElement("a");
    link.className = DETAIL_CLASS;
    link.setAttribute(DETAIL_ATTRIBUTE, "");
    link.setAttribute("href", href);
    /* The label sits in its own span: the anchor is a flex box for centering,
       and a dedicated wrapper keeps the text node stylable on its own. */
    const label = document.createElement("span");
    label.textContent = DETAIL_LABEL;
    link.appendChild(label);
    const title = cardTitleText(card);
    if (title !== "") {
      /* WCAG 2.5.3 Label in Name: the accessible name must CONTAIN the visible
         label, so speech input can activate the control by reading it. Naming
         the product INSTEAD of "the course" would drop the visible words; the
         product is appended to them, not substituted for them. */
      link.setAttribute("aria-label", DETAIL_LABEL + ": " + title);
    }
    return link;
  };

  /* Independent of the variant row: needs no product JSON, so it runs for every
     card in the scan - including the single-variant cards hydration skips. */
  const ensureDetailButton = (card) => {
    const button = cardAddToCartButton(card);
    if (!button) {
      return;
    }
    const container = button.closest(".product-form-buttons");
    if (!container) {
      return;
    }
    if (container.querySelector("." + DETAIL_CLASS)) {
      /* Converge on the WHOLE invariant, not just "a link exists": a morph that
         syncs this container's class attribute from the server HTML while keeping
         its children strips DETAIL_ROW_CLASS and leaves the link behind. The CSS
         is gated on that class, so returning here without re-asserting it would
         leave the row unstyled with no way back short of a reload. */
      container.classList.add(DETAIL_ROW_CLASS);
      card.setAttribute(DETAIL_ATTRIBUTE, "1");
      return;
    }
    /* Insert before whichever ancestor of the button is the direct child of the
       container - a span live, the button itself in the harness - so added or
       removed Horizon wrapper layers cannot break the insertion point. */
    let anchorChild = button;
    while (anchorChild.parentNode && anchorChild.parentNode !== container) {
      anchorChild = anchorChild.parentNode;
    }
    if (anchorChild.parentNode !== container) {
      return;
    }
    const link = buildDetailButton(card);
    if (!link) {
      return;
    }
    container.insertBefore(link, anchorChild);
    container.classList.add(DETAIL_ROW_CLASS);
    card.setAttribute(DETAIL_ATTRIBUTE, "1");
  };

  /* An older asset version may still be live in a bfcache/pageshow restore
     after the script is replaced; without this the retired Read more link and
     the detail button would show at the same time. */
  const sweepLegacyMoreLinks = (card) => {
    const stale = card.querySelectorAll("[data-ndt-card-more]");
    for (let index = 0; index < stale.length; index += 1) {
      stale[index].remove();
    }
  };

  const insertRow = (card, row) => {
    const price = cardPriceNode(card);
    if (price && price.parentNode) {
      price.parentNode.insertBefore(row, price);
      return true;
    }
    const title = card.querySelector('a[ref="productTitleLink"]');
    if (title && title.parentNode) {
      title.parentNode.insertBefore(row, title.nextSibling);
      return true;
    }
    return false;
  };

  const hydrate = (card, model) => {
    if (!model || card.querySelector("." + ROW_CLASS)) {
      return;
    }
    const selectedId = currentVariantId(card);
    const row = buildRow(model, selectedId);
    if (!insertRow(card, row)) {
      card.setAttribute(CARD_FLAG, "skip");
      return;
    }
    /* A re-render can drop the row and keep the slot (or the reverse), and the
       row alone gates this function - clear any leftover slot before inserting
       so a rebuild can never stack two of them. */
    const stale = card.querySelectorAll("[" + DESC_ATTRIBUTE + "], [" + HINT_ATTRIBUTE + "]");
    for (let index = 0; index < stale.length; index += 1) {
      stale[index].remove();
    }
    const map = readDescriptionMap();
    if (anyVariantDescribed(model, map) && row.parentNode) {
      /* ABOVE the row, not below it (operator decision 2026-07-30): the slot goes
         between the title link and the buttons. */
      row.parentNode.insertBefore(
        buildDescription(resolveCardDescription(map, selectedId)),
        row
      );
    }
    if (row.parentNode) {
      /* Directly above the row, so it lands under the description when there is
         one. Inserted after it for that reason. */
      row.parentNode.insertBefore(buildHint(), row);
    }
    MODELS.set(card, model);
    card.setAttribute(CARD_FLAG, "1");
  };

  const prepare = (card) => {
    if (card.querySelector("." + ROW_CLASS)) {
      return;
    }
    const known = MODELS.get(card);
    if (known) {
      /* Horizon re-rendered the card and dropped the row: rebuild from cache. */
      hydrate(card, known);
      return;
    }
    const flag = card.getAttribute(CARD_FLAG);
    if (flag === "skip" || flag === "pending") {
      return;
    }
    if (cardVariantCount(card) === 1) {
      card.setAttribute(CARD_FLAG, "skip");
      return;
    }
    if (!card.querySelector('input[ref="variantId"]') && !cardPriceNode(card)) {
      /* Nothing in this card would follow a selection. */
      card.setAttribute(CARD_FLAG, "skip");
      return;
    }
    const jsonPath = productJsonPath(cardProductUrl(card));
    if (jsonPath === "") {
      card.setAttribute(CARD_FLAG, "skip");
      return;
    }
    card.setAttribute(CARD_FLAG, "pending");
    loadModel(jsonPath).then((model) => {
      hydrate(card, model);
      if (card.getAttribute(CARD_FLAG) === "pending") {
        card.setAttribute(CARD_FLAG, "skip");
      }
    });
  };

  /* The description slot is created with the row, so a map that arrives LATER
     (Custom liquid section saved in the theme editor, or a section rendered
     after the grid) - or a re-render that strips the slot while keeping the row
     - would otherwise stay broken until a full reload. Invariant restored here:
     a card with a row has a slot exactly when its product is described. The
     detail button is NOT maintained here; ensureDetailButton runs for every card
     on every scan, including cards that never get a row. */
  const repairExtras = (card) => {
    const row = card.querySelector("." + ROW_CLASS);
    if (!row || !row.parentNode) {
      return;
    }
    if (!card.querySelector("[" + DESC_ATTRIBUTE + "]")) {
      const map = readDescriptionMap();
      if (anyVariantDescribed(MODELS.get(card), map)) {
        const selected = card.getAttribute("data-ndt-selected-variant") || currentVariantId(card);
        /* Same order as hydrate: blurb, hint, row. Anchoring on the row alone
           would drop a late blurb BETWEEN the hint hydrate already left there
           and the row; anchor on the hint when it is really the row's sibling,
           fall back to the row when a morph moved it elsewhere. */
        const hint = card.querySelector("[" + HINT_ATTRIBUTE + "]");
        const anchor = hint && hint.parentNode === row.parentNode ? hint : row;
        row.parentNode.insertBefore(
          buildDescription(resolveCardDescription(map, selected)),
          anchor
        );
      }
    }
    if (!card.querySelector("[" + HINT_ATTRIBUTE + "]")) {
      row.parentNode.insertBefore(buildHint(), row);
    }
  };

  let viewportObserver = null;

  const ensureObserver = () => {
    if (viewportObserver || typeof window.IntersectionObserver !== "function") {
      return viewportObserver;
    }
    viewportObserver = new window.IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            viewportObserver.unobserve(entry.target);
            prepare(entry.target);
          }
        });
      },
      { rootMargin: "400px 0px" }
    );
    return viewportObserver;
  };

  const scan = () => {
    const cards = document.querySelectorAll("product-card");
    for (let index = 0; index < cards.length; index += 1) {
      const card = cards[index];
      sweepLegacyMoreLinks(card);
      ensureDetailButton(card);
      if (card.querySelector("." + ROW_CLASS)) {
        repairExtras(card);
        continue;
      }
      const cached = MODELS.get(card) || MEMORY.get(productJsonPath(cardProductUrl(card)));
      const observer = cached ? null : ensureObserver();
      if (!observer) {
        prepare(card);
      } else if (!OBSERVED.has(card)) {
        OBSERVED.add(card);
        observer.observe(card);
      }
    }
  };

  let scanScheduled = false;

  const scheduleScan = () => {
    if (scanScheduled) {
      return;
    }
    scanScheduled = true;
    window.setTimeout(() => {
      scanScheduled = false;
      scan();
    }, 120);
  };

  document.addEventListener("click", (event) => {
    const target = event.target;
    const button =
      target && typeof target.closest === "function" ? target.closest("." + BUTTON_CLASS) : null;
    if (!button || button.disabled) {
      return;
    }
    const card = button.closest("product-card");
    if (!card) {
      return;
    }
    /* The whole card surface is an overlay link: keep this click local. */
    event.preventDefault();
    event.stopPropagation();
    if (button.classList.contains(SOON_CLASS)) {
      /* Never selects; flash the same "Soon" bubble the hover shows, so a tap
         (no hover on touch) gets the message too. */
      button.classList.add(SOON_FLASH_CLASS);
      window.setTimeout(() => {
        button.classList.remove(SOON_FLASH_CLASS);
      }, 1200);
      return;
    }
    applyVariant(card, button);
  });

  /* ---- the same Soon gate on the theme's product-page variant picker ---- */

  const pickerRadios = (scope) =>
    (scope || document).querySelectorAll(PICKER_TAG + ' input[type="radio"]');

  /* Horizon renders the SAME option either as a radio or as a <select> option
     (variant-picker.js branches on HTMLSelectElement) and the style is a theme
     setting, so a radio-only gate would die the day that setting is switched -
     silently, on a page that still looks right. */
  const pickerSelects = (scope) =>
    (scope || document).querySelectorAll(PICKER_TAG + " select");

  const selectKey = (select) =>
    select.getAttribute("name") || select.getAttribute("id") || "";

  const optionLabelText = (input) =>
    (input.getAttribute("value") || input.getAttribute("aria-label") || "").trim();

  /* Unavailable wins over soon, exactly as in buildRow(): the theme already has
     its own sold-out treatment for those options and should keep it. */
  const isSoonRadio = (input) =>
    !input.disabled &&
    input.getAttribute("data-option-available") !== "false" &&
    SOON_TITLE_PATTERN.test(optionLabelText(input));

  /* An <option> this gate already handled IS disabled and carries the suffix,
     so here `disabled` cannot mean "someone else's state" and the title has to
     come from the value attribute, which is never rewritten. */
  const isSoonSelectOption = (option) =>
    option.getAttribute("data-option-available") !== "false" &&
    SOON_TITLE_PATTERN.test((option.getAttribute("value") || "").trim());

  /* Last option a shopper (or the server render) legitimately chose, per radio
     group. Stored as the option LABEL, not the element: Horizon replaces the
     input nodes on every morph, so a remembered node would be detached by the
     time a revert needs it. */
  const lastChoice = new Map();

  const flashSoon = (element) => {
    element.classList.add(SOON_FLASH_CLASS);
    window.setTimeout(() => {
      element.classList.remove(SOON_FLASH_CLASS);
    }, 1200);
  };

  const gatePickers = (scope) => {
    /* These courses offer both levels and practice questions. Keep the native
       option keys intact and restore their display label after picker morphs. */
    const pickerScope = scope || document;
    const pickers = typeof pickerScope.matches === "function" && pickerScope.matches(PICKER_TAG)
      ? [pickerScope] : pickerScope.querySelectorAll(PICKER_TAG);
    for (const picker of pickers) {
      if (!COURSE_PICKER_PATH.test(productJsonPath(picker.getAttribute("data-product-url") || ""))) {
        continue;
      }
      for (const heading of picker.querySelectorAll("legend, .variant-option--dropdowns > label")) {
        if ((heading.textContent || "").trim() === "Choose") {
          heading.textContent = COURSE_PICKER_LABEL;
        }
      }
    }
    const radios = pickerRadios(scope);
    for (let index = 0; index < radios.length; index += 1) {
      const radio = radios[index];
      const label =
        typeof radio.closest === "function" ? radio.closest("." + PICKER_LABEL_CLASS) : null;
      if (!label) {
        continue;
      }
      if (!isSoonRadio(radio)) {
        if (radio.checked) {
          lastChoice.set(radio.getAttribute("name") || "", optionLabelText(radio));
        }
        continue;
      }
      radio.setAttribute("aria-disabled", "true");
      label.classList.add(SOON_CLASS);
      label.setAttribute("title", SOON_LABEL);
      if (!label.querySelector("." + PICKER_BUBBLE_CLASS)) {
        /* A real span, not a ::after: the theme already uses BOTH pseudo-
           elements of this label (:before = the option border, :after = the
           unavailable strike), and the label clips its overflow - the
           stylesheet lifts that for a gated one. */
        const bubble = document.createElement("span");
        bubble.className = PICKER_BUBBLE_CLASS;
        bubble.setAttribute("aria-hidden", "true");
        bubble.textContent = SOON_LABEL;
        label.appendChild(bubble);
      }
    }
    const selects = pickerSelects(scope);
    for (let index = 0; index < selects.length; index += 1) {
      const select = selects[index];
      const chosen = select.options[select.selectedIndex];
      if (chosen && !isSoonSelectOption(chosen)) {
        lastChoice.set(selectKey(select), chosen.value);
      }
      for (let inner = 0; inner < select.options.length; inner += 1) {
        const option = select.options[inner];
        if (!isSoonSelectOption(option) || option.hasAttribute(SOON_FLAG)) {
          continue;
        }
        option.setAttribute(SOON_FLAG, "");
        option.disabled = true;
        /* A native select cannot carry the bubble, so the reason goes in the
           label. Horizon matches on option.value, which is left untouched. */
        option.textContent = (option.textContent || "").trim() + " (" + SOON_LABEL + ")";
      }
    }
  };

  /* Capture phase: cancel the label activation before it can check the radio,
     and before Horizon's own listeners see the click at all. */
  document.addEventListener(
    "click",
    (event) => {
      const target = event.target;
      const label =
        target && typeof target.closest === "function"
          ? target.closest("." + PICKER_LABEL_CLASS + "." + SOON_CLASS)
          : null;
      if (!label || !label.closest(PICKER_TAG)) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      flashSoon(label);
    },
    true
  );

  /* Arrow keys move a radio group with no click at all, so the click gate on
     its own leaves a keyboard path straight to the option: revert the change
     before Horizon (or our own description swap) can act on it. */
  /* `change` has no default action to cancel: keeping the event away from
     Horizon (and from our own description swap) IS the revert. */
  const stopChange = (event) => {
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }
  };

  document.addEventListener(
    "change",
    (event) => {
      const target = event.target;
      if (!target || typeof target.closest !== "function") {
        return;
      }
      const picker = target.closest(PICKER_TAG);
      if (!picker) {
        return;
      }
      if (target.tagName === "SELECT") {
        /* `disabled` already blocks pointer and keyboard; this catches a
           programmatic `.value =` (deep-link handler, another script). */
        const chosen = target.options[target.selectedIndex];
        const key = selectKey(target);
        if (!chosen || !isSoonSelectOption(chosen)) {
          if (chosen) {
            lastChoice.set(key, chosen.value);
          }
          return;
        }
        stopChange(event);
        const wantedValue = lastChoice.get(key);
        if (wantedValue !== undefined) {
          target.value = wantedValue;
        }
        return;
      }
      const radio = target;
      if (radio.type !== "radio") {
        return;
      }
      const group = radio.getAttribute("name") || "";
      if (!isSoonRadio(radio)) {
        if (radio.checked) {
          lastChoice.set(group, optionLabelText(radio));
        }
        return;
      }
      stopChange(event);
      radio.checked = false;
      const wanted = lastChoice.get(group);
      if (wanted) {
        const siblings = pickerRadios(picker);
        for (let index = 0; index < siblings.length; index += 1) {
          if (
            (siblings[index].getAttribute("name") || "") === group &&
            optionLabelText(siblings[index]) === wanted
          ) {
            siblings[index].checked = true;
            break;
          }
        }
      }
      const label = radio.closest("." + PICKER_LABEL_CLASS);
      if (label) {
        flashSoon(label);
      }
    },
    true
  );

  const soonSelected = () => {
    const radios = pickerRadios();
    for (let index = 0; index < radios.length; index += 1) {
      if (radios[index].checked && isSoonRadio(radios[index])) {
        return true;
      }
    }
    const selects = pickerSelects();
    for (let index = 0; index < selects.length; index += 1) {
      const chosen = selects[index].options[selects[index].selectedIndex];
      if (chosen && isSoonSelectOption(chosen)) {
        return true;
      }
    }
    return false;
  };

  /* Horizon morphs ONLY <variant-picker> on a variant click, which throws away
     the gated markup: variant:update is the event that says it just happened. */
  document.addEventListener("variant:update", () => {
    gatePickers();
  });

  const scanAndGate = () => {
    scan();
    gatePickers();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scanAndGate);
  } else {
    scanAndGate();
  }
  document.addEventListener("shopify:section:load", () => {
    /* A re-saved Custom liquid section can add or change map entries. */
    descriptionMap = null;
    scheduleScan();
    gatePickers();
  });
  window.addEventListener("pageshow", () => {
    scheduleScan();
    gatePickers();
  });

  if (typeof window.MutationObserver === "function") {
    const cardsAdded = (records) => {
      for (let index = 0; index < records.length; index += 1) {
        const added = records[index].addedNodes || [];
        for (let inner = 0; inner < added.length; inner += 1) {
          const node = added[inner];
          if (!node || node.nodeType !== 1 || typeof node.matches !== "function") {
            continue;
          }
          if (node.matches("product-card") || node.querySelector("product-card")) {
            return true;
          }
        }
      }
      return false;
    };
    /* The injected bubble is neither a picker nor an option label, so gating
       can never re-trigger this observer through its own mutation. */
    const pickerTouched = (records) => {
      const selector = PICKER_TAG + ", ." + PICKER_LABEL_CLASS;
      for (let index = 0; index < records.length; index += 1) {
        const added = records[index].addedNodes || [];
        for (let inner = 0; inner < added.length; inner += 1) {
          const node = added[inner];
          if (!node || node.nodeType !== 1 || typeof node.matches !== "function") {
            continue;
          }
          if (node.matches(selector) || node.querySelector(selector)) {
            return true;
          }
        }
      }
      return false;
    };
    new window.MutationObserver((records) => {
      if (cardsAdded(records)) {
        scheduleScan();
      }
      if (pickerTouched(records)) {
        gatePickers();
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Operator escape hatch after an Admin edit: window.__ndtCardVariantsRuntime
     .clearCache() drops every cache and rebuilds the rows without a reload. */
  const clearCache = () => {
    MEMORY.clear();
    PENDING.clear();
    descriptionMap = null;
    try {
      const stale = [];
      for (let index = 0; index < window.sessionStorage.length; index += 1) {
        const key = window.sessionStorage.key(index);
        if (key && key.indexOf("ndt:cardVariants:") === 0) {
          stale.push(key);
        }
      }
      stale.forEach((key) => window.sessionStorage.removeItem(key));
    } catch (error) {
      /* Storage unavailable: the in-memory caches are already cleared. */
    }
    const cards = document.querySelectorAll("product-card");
    for (let index = 0; index < cards.length; index += 1) {
      const card = cards[index];
      const injected = card.querySelectorAll(
        "." + ROW_CLASS + ", [" + DESC_ATTRIBUTE + "], [" + HINT_ATTRIBUTE + "], ." + DETAIL_CLASS
      );
      for (let inner = 0; inner < injected.length; inner += 1) {
        injected[inner].remove();
      }
      const actions = card.querySelector("." + DETAIL_ROW_CLASS);
      if (actions) {
        actions.classList.remove(DETAIL_ROW_CLASS);
      }
      card.removeAttribute(CARD_FLAG);
      card.removeAttribute(DETAIL_ATTRIBUTE);
      MODELS.delete(card);
      OBSERVED.delete(card);
    }
    scan();
    gatePickers();
  };

  /* window.__ndtCardVariantsRuntime.diagnose() - one call that says which link
     of the chain is missing: runtime version, whether the Custom liquid map is
     on the page, and per card whether its variants are covered by that map. */
  const diagnose = () => {
    const map = readDescriptionMap();
    const cards = document.querySelectorAll("product-card");
    const detail = [];
    for (let index = 0; index < cards.length; index += 1) {
      const card = cards[index];
      const model = MODELS.get(card);
      const ids = [];
      let described = 0;
      if (model) {
        for (let inner = 0; inner < model.variants.length; inner += 1) {
          ids.push(model.variants[inner].id);
          if (resolveCardDescription(map, model.variants[inner].id) !== "") {
            described += 1;
          }
        }
      }
      detail.push({
        product: productJsonPath(cardProductUrl(card)),
        state: card.getAttribute(CARD_FLAG) || "untouched",
        buttons: card.querySelectorAll("." + BUTTON_CLASS).length,
        hasSlot: !!card.querySelector("[" + DESC_ATTRIBUTE + "]"),
        hasDetail: !!card.querySelector("." + DETAIL_CLASS),
        variantIds: ids,
        describedVariants: described,
      });
    }
    return {
      version: RUNTIME_VERSION,
      mapPresent: !!map,
      mapEntries: map ? Object.keys(map).length : 0,
      cards: cards.length,
      rows: document.querySelectorAll("." + ROW_CLASS).length,
      slots: document.querySelectorAll("[" + DESC_ATTRIBUTE + "]").length,
      hints: document.querySelectorAll("[" + HINT_ATTRIBUTE + "]").length,
      detailButtons: document.querySelectorAll("." + DETAIL_CLASS).length,
      /* Product page: the theme's own picker and how many of its options the
         soon gate is holding - the operator's only probe for that surface. */
      pickers: document.querySelectorAll(PICKER_TAG).length,
      soonOptions:
        document.querySelectorAll("." + PICKER_LABEL_CLASS + "." + SOON_CLASS).length +
        document.querySelectorAll(PICKER_TAG + " select option[" + SOON_FLAG + "]").length,
      /* A deep link (?variant=<soon>) can server-render the gated option AS the
         selection. The gate refuses new selections, it cannot un-sell that one,
         so report the state rather than let it look identical to a clean page. */
      soonSelected: soonSelected(),
      cardDetail: detail,
    };
  };

  window[GLOBAL_KEY] = {
    version: RUNTIME_VERSION,
    scan: scan,
    productJsonPath: productJsonPath,
    withVariantParam: withVariantParam,
    buildVariantModel: buildVariantModel,
    formatMoneyLike: formatMoneyLike,
    resolveCardDescription: resolveCardDescription,
    anyVariantDescribed: anyVariantDescribed,
    unpackCacheEntry: unpackCacheEntry,
    clearCache: clearCache,
    gatePickers: gatePickers,
    diagnose: diagnose,
  };
})();

/* NDT one-per-order quantity cap. (operator 2026-08-13)
   ------------------------------------------------------------------------
   Every product here is a single-seat course, and the EDU grant is an upsert on
   (user, sku) - `user_sku_access` - so a line bought at quantity 3 grants the
   same ONE access at three times the price. The cap is therefore store-wide.

   This module deliberately implements almost nothing. Horizon's own
   QuantitySelectorComponent already honours the input's `max` attribute
   (component-quantity-selector.js, read from the live CDN 2026-08-13): it
   disables the plus button, clamps a typed value in setQuantity(), and
   product-form.js refuses the add and shows its own
   `data-quantity-error-max` ("This item has a maximum of 1") when
   canAddToCart() fails. So the feature is exactly three things:

     1. put max="1" on every quantity input, on every surface;
     2. put it BACK, because product-form.js calls
        updateConstraints(min, max || null, step) with the new variant's
        server-rendered html on each variant switch and a DTC store's
        quantity_rule.max is null - which REMOVES the attribute;
     3. for a cart line that is already above the cap (an older cart, or a
        /cart/add?quantity=3 permalink), drive the theme's OWN update path so
        the server cart really changes. Rewriting the input value alone would
        show 1 while the cart still charges 3.

   Not enforcement: /cart/add?quantity=3 followed by /checkout never renders a
   page this runtime can reach. Genuine enforcement is a Shopify cart/checkout
   validation Function, i.e. an Admin/app change - the same honest limit the
   Level 3 "Soon" gate carries. */
(() => {
  const GLOBAL_KEY = "__ndtQuantityCapRuntime";
  if (window[GLOBAL_KEY]) {
    return;
  }

  const RUNTIME_VERSION = 1;
  const MAX_PER_ORDER = 1;
  /* Both surfaces: the product form (and the quick-add dialog, which renders a
     product form) and the cart page/drawer, whose component subclasses the
     product one. Tag names are the contract; the class is only for styling. */
  const COMPONENTS = "quantity-selector-component, cart-quantity-selector-component";
  const INPUT_SELECTOR =
    'input[ref="quantityInput"], input[name="quantity"], input[name="updates[]"]';
  const CAP_CLASS = "ndt-qty-capped";
  const NOTE_CLASS = "ndt-qty-cap-note";
  const NOTE_TEXT = "One seat per order";
  const REPAIRED_CLASS = "ndt-qty-cap-repaired";
  const REPAIRED_TEXT = "Reduced to 1 - one seat per order.";
  /* A cart whose update keeps failing must not be retried forever. Each attempt
     costs one server round trip (Horizon dispatches cart:update only on a real
     cart response), so this is a backstop, not the loop guard. */
  const MAX_REPAIR_ATTEMPTS = 3;

  /* Cart state keyed by LINE NUMBER, not by node: Horizon's morph patches the
     existing row in place as often as it replaces it, so a flag on the element
     is neither reliably fresh nor reliably gone. `repaired` drives the notice
     (which a morph does wipe), `pending` suppresses a re-fire while a driven
     update has not shown up in the value yet, `attempts` is the backstop. */
  const repaired = new Set();
  const pending = new Set();
  const attempts = new Map();

  const quantityInputOf = (component) => {
    if (!component || typeof component.querySelector !== "function") {
      return null;
    }
    return component.querySelector(INPUT_SELECTOR);
  };

  const readInt = (value, fallback) => {
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? fallback : parsed;
  };

  const isCartComponent = (component) =>
    (component.tagName || "").toLowerCase() === "cart-quantity-selector-component";

  /* The theme reads `max` live in getCurrentValues() on every interaction, so
     the attribute alone is the whole clamp. updateConstraints() is deliberately
     NOT used to set it: that method also re-clamps the current VALUE without
     telling the cart, which is exactly the display-says-1-cart-charges-3 bug. */
  const capInput = (component, input) => {
    if (input.getAttribute("max") !== String(MAX_PER_ORDER)) {
      input.setAttribute("max", String(MAX_PER_ORDER));
      if (typeof component.updateButtonStates === "function") {
        /* Button states are derived from max: without this the plus stays
           clickable until the shopper's first interaction. */
        component.updateButtonStates();
      }
    }
  };

  const addNote = (component) => {
    if (component.querySelector("." + NOTE_CLASS)) {
      return;
    }
    /* A real span rather than a ::after, for the same reason the Soon bubble is
       one: the theme owns these pseudo-elements, and a node can be found and
       counted by diagnose(). aria-hidden because the limit is already spoken by
       the theme's own live-region error on an add attempt. */
    const note = document.createElement("span");
    note.className = NOTE_CLASS;
    note.setAttribute("aria-hidden", "true");
    note.textContent = NOTE_TEXT;
    component.appendChild(note);
  };

  const showRepairedNotice = (component) => {
    const holder = component.parentNode;
    if (!holder || typeof holder.querySelector !== "function") {
      return;
    }
    if (holder.querySelector("." + REPAIRED_CLASS)) {
      return;
    }
    const notice = document.createElement("span");
    notice.className = REPAIRED_CLASS;
    notice.setAttribute("role", "status");
    notice.textContent = REPAIRED_TEXT;
    /* After the component, not inside: the component is a flex row of two
       buttons and an input, and a block child would break that row. */
    if (typeof component.insertAdjacentElement === "function") {
      component.insertAdjacentElement("afterend", notice);
    } else {
      holder.appendChild(notice);
    }
  };

  /* A cart line above the cap: hand the theme its own event object and let
     setQuantity() clamp, write the value and dispatch
     QuantitySelectorUpdateEvent, which cart-items-component turns into the real
     /cart/change. Falls back to the native events the theme binds (`on:blur=
     "/setQuantity"`) when the element has not upgraded yet. */
  const repairCartLine = (component, input) => {
    const line = readInt(input.getAttribute("data-cart-line"), 0);
    if (!line) {
      /* No line number: a partial or foreign render. There is nothing to change
         on the server, and rewriting the value would show a quantity the cart
         does not have. */
      return false;
    }
    const value = readInt(input.value, 0);
    if (value <= MAX_PER_ORDER) {
      /* The theme wrote the clamped value, so any driven update is through. */
      pending.delete(line);
      return false;
    }
    if (pending.has(line)) {
      return false;
    }
    const tries = attempts.get(line) || 0;
    if (tries >= MAX_REPAIR_ATTEMPTS) {
      return false;
    }
    pending.add(line);
    attempts.set(line, tries + 1);
    const syntheticEvent = { target: input, preventDefault: () => {} };
    if (typeof component.setQuantity === "function") {
      /* The theme clamps to the cap, writes the value and dispatches
         QuantitySelectorUpdateEvent, which cart-items-component turns into the
         real /cart/change. */
      component.setQuantity(syntheticEvent);
    } else {
      /* Not upgraded yet: fire the events the theme binds declaratively
         (`on:blur="/setQuantity"`) so a late upgrade still performs the change. */
      input.value = String(MAX_PER_ORDER);
      input.dispatchEvent(new Event("change", { bubbles: true }));
      input.dispatchEvent(new Event("blur", { bubbles: true }));
    }
    repaired.add(line);
    return true;
  };

  const capComponent = (component) => {
    const input = quantityInputOf(component);
    if (!input) {
      return;
    }
    const line = readInt(input.getAttribute("data-cart-line"), 0);
    if (isCartComponent(component) || line) {
      /* Cart: the value IS the cart quantity, so it may only change through the
         theme's update path. Cap first so setQuantity() clamps to 1. */
      capInput(component, input);
      repairCartLine(component, input);
      if (line && repaired.has(line)) {
        showRepairedNotice(component);
      }
    } else {
      capInput(component, input);
      /* Product form: the value is a not-yet-submitted intent, so clamping it
         for display costs nothing and touches no cart. */
      if (readInt(input.value, 1) > MAX_PER_ORDER) {
        input.value = String(MAX_PER_ORDER);
        if (typeof component.updateButtonStates === "function") {
          component.updateButtonStates();
        }
      }
    }
    component.classList.add(CAP_CLASS);
    addNote(component);
  };

  const capAll = (scope) => {
    const components = (scope || document).querySelectorAll(COMPONENTS);
    for (let index = 0; index < components.length; index += 1) {
      capComponent(components[index]);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => capAll());
  } else {
    capAll();
  }
  /* variant:update - product-form.js has just wiped `max` (see the header).
     cart:update - the cart page and drawer morph their rows.
     Both are Horizon's own bubbling events (assets/events.js). */
  document.addEventListener("variant:update", () => capAll());
  document.addEventListener("cart:update", () => capAll());
  document.addEventListener("shopify:section:load", () => capAll());
  window.addEventListener("pageshow", () => capAll());

  if (typeof window.MutationObserver === "function") {
    /* The note and the notice are plain spans, so capping can never re-trigger
       this observer through its own mutation. */
    const componentsAdded = (records) => {
      for (let index = 0; index < records.length; index += 1) {
        const added = records[index].addedNodes || [];
        for (let inner = 0; inner < added.length; inner += 1) {
          const node = added[inner];
          if (!node || node.nodeType !== 1 || typeof node.matches !== "function") {
            continue;
          }
          if (node.matches(COMPONENTS) || node.querySelector(COMPONENTS)) {
            return true;
          }
        }
      }
      return false;
    };
    new window.MutationObserver((records) => {
      if (componentsAdded(records)) {
        capAll();
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* window.__ndtQuantityCapRuntime.diagnose() - the operator's one-call probe:
     how many quantity selectors this page has, how many carry the cap, and
     which cart lines arrived above it (a permalink tell). */
  const diagnose = () => {
    const components = document.querySelectorAll(COMPONENTS);
    const overLimitLines = [];
    let capped = 0;
    for (let index = 0; index < components.length; index += 1) {
      const component = components[index];
      const input = quantityInputOf(component);
      if (!input) {
        continue;
      }
      if (input.getAttribute("max") === String(MAX_PER_ORDER)) {
        capped += 1;
      }
      const line = readInt(input.getAttribute("data-cart-line"), 0);
      if (line && readInt(input.value, 0) > MAX_PER_ORDER) {
        overLimitLines.push(line);
      }
    }
    return {
      version: RUNTIME_VERSION,
      max: MAX_PER_ORDER,
      components: components.length,
      capped: capped,
      notes: document.querySelectorAll("." + NOTE_CLASS).length,
      repairedLines: Array.from(repaired),
      overLimitLines: overLimitLines,
      /* A line still above the cap AND out of attempts means the cart refused
         the change - the tell that this needs the cart looked at, not a reload. */
      gaveUpLines: Array.from(attempts.keys()).filter(
        (line) => (attempts.get(line) || 0) >= MAX_REPAIR_ATTEMPTS
      ),
    };
  };

  window[GLOBAL_KEY] = {
    version: RUNTIME_VERSION,
    max: MAX_PER_ORDER,
    capAll: capAll,
    diagnose: diagnose,
  };
})();
